var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "summary" },
    [
      _c("div", {
        staticClass: "summary-overlay",
        class: {
          "summary-overlay-active": _vm.statuses.changeStatusForm.length > 0,
        },
        on: {
          click: function ($event) {
            _vm.statuses.changeStatusForm = ""
          },
        },
      }),
      _c("new-transaction-modal", {
        ref: "typeModal",
        on: { submitted: _vm.modalIsSubmitted },
      }),
      _c("m-finance-transaction", {
        ref: "depositModal",
        attrs: {
          active: _vm.isShowDepositTransactionModal,
          type: "deposit",
          "current-user-personal-amount": _vm.money.depositLocalValue,
        },
        on: {
          close: function ($event) {
            _vm.isShowDepositTransactionModal = false
          },
          submitDeposit: _vm.addDataToDeposit,
        },
      }),
      _c("m-finance-transaction", {
        attrs: {
          active: _vm.isShowPersonalAccountTransactionModal,
          type: "personal_account",
        },
        on: {
          close: function ($event) {
            _vm.isShowPersonalAccountTransactionModal = false
          },
          submitPersonalAccount: _vm.addDataToPersonalAccount,
        },
      }),
      _c("div", { staticClass: "summary-container-desktop" }, [
        _vm.userHavePermissionMainFactors() ||
        _vm.userHavePermissionFinesAndEncourage()
          ? _c("div", { staticClass: "d-flex flex-column w-100" }, [
              _vm.userHavePermissionMainFactors()
                ? _c(
                    "div",
                    { staticClass: "summary-general" },
                    [
                      _vm.general.isLoaded
                        ? _c(
                            "div",
                            { staticClass: "summary-general-loader" },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: _vm.icon, spin: "" },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.general.isLoaded
                        ? _c("div", { staticClass: "summary-general-title" }, [
                            _vm._v("Основные показатели"),
                          ])
                        : _vm._e(),
                      !_vm.general.isLoaded
                        ? _c("c-switcher", {
                            staticClass: "summary-general-tabs",
                            attrs: {
                              type: "group",
                              items: [
                                { label: "Сегодня", value: "today" },
                                { label: "Неделя", value: "sunday" },
                                {
                                  label: "Текущий месяц",
                                  value: "currentMonth",
                                },
                                {
                                  label: "Прошлый месяц",
                                  value: "previousMonth",
                                },
                              ],
                            },
                            model: {
                              value: _vm.general.tabsLocal,
                              callback: function ($$v) {
                                _vm.$set(_vm.general, "tabsLocal", $$v)
                              },
                              expression: "general.tabsLocal",
                            },
                          })
                        : _vm._e(),
                      !_vm.general.isLoaded
                        ? _c("div", { staticClass: "summary-general-main" }, [
                            _c(
                              "div",
                              { staticClass: "summary-general-main-salary" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-main-salary-amount",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.general[_vm.general.tabsLocal]
                                              .salary
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.currencyLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-main-salary-month",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal]
                                          .interval
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "summary-general-main-additionally",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-main-additionally-item",
                                  },
                                  [
                                    _c("c-button", {
                                      staticClass:
                                        "summary-general-main-additionally-item-icon",
                                      attrs: { size: "iconic", icon: "time" },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-general-main-additionally-item-text",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.general[_vm.general.tabsLocal]
                                                .hoursWorked
                                            ) +
                                            " / " +
                                            _vm._s(
                                              _vm.general[_vm.general.tabsLocal]
                                                .daysWorked
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-main-additionally-item",
                                  },
                                  [
                                    _c("c-button", {
                                      staticClass:
                                        "summary-general-main-additionally-item-icon",
                                      attrs: { size: "iconic", icon: "point" },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-general-main-additionally-item-text",
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.general[_vm.general.tabsLocal]
                                              .point
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      !_vm.general.isLoaded
                        ? _c("div", { staticClass: "summary-general-money" }, [
                            _c(
                              "div",
                              { staticClass: "summary-general-money-item" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-amount",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.general[_vm.general.tabsLocal]
                                              .money.main.amount
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.currencyLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-title",
                                  },
                                  [_vm._v("Основная часть")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "summary-general-money-item",
                                class: {
                                  "summary-general-money-item-green":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .variable.amount > 0,
                                  "summary-general-money-item-gray":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .variable.amount === 0,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-amount",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.general[_vm.general.tabsLocal]
                                              .money.variable.amount
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.currencyLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-title",
                                  },
                                  [_vm._v("Переменная часть")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "summary-general-money-item",
                                class: {
                                  "summary-general-money-item-red":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .depremal.amount > 0,
                                  "summary-general-money-item-gray":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .depremal.amount === 0,
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-amount",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.general[_vm.general.tabsLocal]
                                              .money.depremal.amount
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.currencyLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-title",
                                  },
                                  [_vm._v("Депрем-е")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "summary-general-money-item",
                                class: {
                                  "summary-general-money-item-green":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .encouragement.amount > 0,
                                  "summary-general-money-item-gray":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .encouragement.amount === 0,
                                },
                              },
                              [
                                _vm.general[_vm.general.tabsLocal].money
                                  .encouragement.count > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-general-money-item-count",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.general[_vm.general.tabsLocal]
                                                .money.encouragement.count
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-amount",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.general[_vm.general.tabsLocal]
                                              .money.encouragement.amount
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.currencyLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-title",
                                  },
                                  [_vm._v("Поощрения")]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "summary-general-money-item",
                                class: {
                                  "summary-general-money-item-red":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .fines.amount > 0,
                                  "summary-general-money-item-gray":
                                    _vm.general[_vm.general.tabsLocal].money
                                      .fines.amount === 0,
                                },
                              },
                              [
                                _vm.general[_vm.general.tabsLocal].money.fines
                                  .count > 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-general-money-item-count",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.general[_vm.general.tabsLocal]
                                                .money.fines.count
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-amount",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatAmount(
                                            _vm.general[_vm.general.tabsLocal]
                                              .money.fines.amount
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.currencyLabel) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-general-money-item-title",
                                  },
                                  [_vm._v("Штрафы")]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.userHavePermissionFinesAndEncourage()
                ? _c("div", { staticClass: "d-flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "summary-encourage",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "personal-employee-discipline",
                            })
                          },
                        },
                      },
                      [
                        _vm.encourageIsLoaded
                          ? _c(
                              "div",
                              { staticClass: "summary-encourage-loader" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: _vm.icon, spin: "" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.encourageIsLoaded
                          ? _c(
                              "div",
                              { staticClass: "summary-encourage-title" },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "14",
                                      height: "15",
                                      viewBox: "0 0 14 15",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M4.04837 13.1935H2.21935C1.89596 13.1935 1.58581 13.065 1.35714 12.8363C1.12847 12.6077 1 12.2975 1 11.9741V7.70642C1 7.38302 1.12847 7.07288 1.35714 6.84421C1.58581 6.61553 1.89596 6.48707 2.21935 6.48707H4.04837M8.31609 5.26772V2.82902C8.31609 2.34394 8.12339 1.87872 7.78038 1.53571C7.43737 1.1927 6.97215 1 6.48707 1L4.04837 6.48707V13.1935H10.9255C11.2196 13.1968 11.5049 13.0937 11.729 12.9033C11.9531 12.7128 12.1007 12.4478 12.1448 12.157L12.9862 6.66997C13.0127 6.49521 13.0009 6.31677 12.9516 6.14702C12.9024 5.97727 12.8168 5.82026 12.7008 5.68688C12.5848 5.55349 12.4412 5.44692 12.2799 5.37454C12.1187 5.30217 11.9436 5.26572 11.7668 5.26772H8.31609Z",
                                        stroke: "#12C971",
                                        "stroke-width": "2",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                      },
                                    }),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "summary-encourage-title-text",
                                  },
                                  [_vm._v("Поощрения")]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._l(_vm.encourageLocalItems, function (item, i) {
                          return _c(
                            "div",
                            {
                              key: `encourage-s-${i}-${item.name}`,
                              staticClass: "summary-encourage-item",
                            },
                            [
                              !_vm.encourageIsLoaded
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-encourage-item-text",
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "summary-encourage-item-date",
                                      },
                                      [_vm._v(_vm._s(item.date))]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        !_vm.encourageIsLoaded &&
                        _vm.encourageLocalItems.length === 0
                          ? _c(
                              "div",
                              { staticClass: "summary-encourage-empty" },
                              [_vm._v(" Поощрений пока нет ")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "summary-fines",
                        on: {
                          click: function ($event) {
                            return _vm.$router.push({
                              name: "personal-employee-discipline",
                            })
                          },
                        },
                      },
                      [
                        _vm.finesIsLoaded
                          ? _c(
                              "div",
                              { staticClass: "summary-fines-loader" },
                              [
                                _c("font-awesome-icon", {
                                  attrs: { icon: _vm.icon, spin: "" },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.finesIsLoaded
                          ? _c("div", { staticClass: "summary-fines-title" }, [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "14",
                                    height: "15",
                                    viewBox: "0 0 14 15",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M4.04837 1.06457H2.21935C1.89596 1.06457 1.58581 1.19304 1.35714 1.42171C1.12847 1.65039 1 1.96053 1 2.28392V6.55164C1 6.87503 1.12847 7.18518 1.35714 7.41385C1.58581 7.64252 1.89596 7.77099 2.21935 7.77099H4.04837M8.31609 8.99034V11.429C8.31609 11.9141 8.12339 12.3793 7.78038 12.7223C7.43737 13.0654 6.97215 13.2581 6.48707 13.2581L4.04837 7.77099V1.06457H10.9255C11.2196 1.06125 11.5049 1.16431 11.729 1.35478C11.9531 1.54524 12.1007 1.81026 12.1448 2.10102L12.9862 7.58809C13.0127 7.76285 13.0009 7.94128 12.9516 8.11103C12.9024 8.28079 12.8168 8.43779 12.7008 8.57118C12.5848 8.70456 12.4412 8.81114 12.2799 8.88351C12.1187 8.95589 11.9436 8.99234 11.7668 8.99034H8.31609Z",
                                      stroke: "#FF238D",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "summary-fines-title-text" },
                                [_vm._v("Частые нарушения")]
                              ),
                            ])
                          : _vm._e(),
                        _vm._l(_vm.finesLocalItems, function (fine) {
                          return _c(
                            "div",
                            {
                              key: `fine-${fine.name}`,
                              staticClass: "summary-fines-item",
                            },
                            [
                              !_vm.finesIsLoaded
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "summary-fines-item-text",
                                      },
                                      [_vm._v(_vm._s(fine.name))]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "summary-fines-item-count",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "summary-fines-item-count-text",
                                          },
                                          [_vm._v(_vm._s(fine.count))]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        !_vm.finesIsLoaded && _vm.finesLocalItems.length === 0
                          ? _c("div", { staticClass: "summary-fines-empty" }, [
                              _vm._v(" Нарушений пока нет "),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _c("div", { staticClass: "d-flex flex-column w-100 summary-ml" }, [
          _c("div", { staticClass: "summary-money" }, [
            _vm.money.isLoaded
              ? _c(
                  "div",
                  { staticClass: "summary-money-loader" },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: _vm.icon, spin: "" },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.money.isLoaded
              ? _c(
                  "div",
                  {
                    staticClass: "summary-money-item summary-money-item-yellow",
                    class: {
                      "summary-money-item-yellow":
                        _vm.money.depositLocalValue > 0 &&
                        _vm.money.depositLocalValue <= 1000,
                      "summary-money-item-green":
                        _vm.money.depositLocalValue === 3000,
                      "summary-money-item-red":
                        _vm.money.depositLocalValue <= 0 ||
                        _vm.money.depositLocalValue > 3000,
                      "summary-money-item-clickable":
                        _vm.userHavePermissionUpdateWorkerDeposit(),
                    },
                    on: { click: _vm.showDepositModal },
                  },
                  [
                    _c("div", { staticClass: "summary-money-item-title" }, [
                      _vm._v("Депозит"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "summary-money-item-amount" },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-money-item-amount-text" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatAmountWithNegative(
                                    _vm.money.depositLocalValue
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.currencyLabel) +
                                " "
                            ),
                          ]
                        ),
                        _vm.userHavePermissionUpdateWorkerDeposit()
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: "Редактировать",
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Редактировать',\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass: "summary-money-item-amount-edit",
                              attrs: { icon: "edit", size: "iconic" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.money.isLoaded
              ? _c(
                  "div",
                  {
                    staticClass: "summary-money-item",
                    class: {
                      "summary-money-item-green":
                        _vm.money.personalAccountValue > 0,
                      "summary-money-item-red":
                        _vm.money.personalAccountValue < 0,
                      "summary-money-item-clickable":
                        _vm.userHavePermissionUpdatePersonalAmount(),
                    },
                    on: {
                      click: function ($event) {
                        _vm.userHavePermissionUpdatePersonalAmount()
                          ? _vm.$refs.typeModal.open()
                          : ""
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "summary-money-item-title" }, [
                      _vm._v("Личный счёт"),
                    ]),
                    _c(
                      "div",
                      { staticClass: "summary-money-item-amount" },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-money-item-amount-text" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatAmountWithNegative(
                                    _vm.money.personalAccountValue
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.currencyLabel) +
                                " "
                            ),
                          ]
                        ),
                        _vm.userHavePermissionUpdatePersonalAmount()
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: "Редактировать",
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Редактировать',\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass: "summary-money-item-amount-edit",
                              attrs: { icon: "edit", size: "iconic" },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            !_vm.money.isLoaded
              ? _c("div", { staticClass: "summary-money-item" }, [
                  _c("div", { staticClass: "summary-money-item-title" }, [
                    _vm._v("Прем. счет"),
                  ]),
                  _c("div", { staticClass: "summary-money-item-amount" }, [
                    _c(
                      "div",
                      { staticClass: "summary-money-item-amount-text" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatAmountWithNegative(
                                _vm.money.premiumAccountValue
                              )
                            ) +
                            " " +
                            _vm._s(_vm.currencyLabel) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "d-flex" }, [
            _vm.userHavePermissionExpiredAndNeedAddDocuments()
              ? _c(
                  "div",
                  {
                    staticClass: "summary-documents",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "personal-employee-documents",
                        })
                      },
                    },
                  },
                  [
                    _vm.documents.isLoaded
                      ? _c(
                          "div",
                          { staticClass: "summary-documents-loader" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.needToAdd.length > 0
                      ? _c("div", { staticClass: "summary-documents-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Необходимо добавить обязательные документы: <b>${_vm.documents.needToAdd}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Необходимо добавить обязательные документы: <b>${documents.needToAdd}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-documents-item-icon summary-documents-item-icon-yellow",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M8.96875 1H1V15H7M8.96875 1L12 4.03125M8.96875 1V4.03125H12M12 4.03125V5M9 12H12M12 12H15M12 12V9M12 12V15",
                                      stroke: "#9FA400",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.documents.needToAdd))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.needToAdd.length > 0
                      ? _c("div", { staticClass: "summary-documents-hr" })
                      : _vm._e(),
                    !_vm.documents.isLoaded && _vm.documents.expired.length > 0
                      ? _c("div", { staticClass: "summary-documents-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Истёк срок годности у документов: <b>${_vm.documents.expired}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Истёк срок годности у документов: <b>${documents.expired}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-documents-item-icon summary-documents-item-icon-red",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM8.96875 1L9.67586 0.292893L9.38296 0H8.96875V1ZM12 4.03125H13V3.61704L12.7071 3.32414L12 4.03125ZM8.96875 4.03125H7.96875V5.03125H8.96875V4.03125ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14V16ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9H16ZM15 12V13H16V12H15ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13V11ZM13.4944 10.3333L14.3259 9.77772L13.4944 10.3333ZM10.4147 9.05765L10.2196 8.07686L10.4147 9.05765ZM8.87868 9.87868L9.58579 10.5858L8.87868 9.87868ZM8.05765 11.4147L7.07686 11.2196L8.05765 11.4147ZM9.33329 14.4944L8.77772 15.3259L9.33329 14.4944ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM0 1V15H2V1H0ZM8.96875 0H1V2H8.96875V0ZM8.26164 1.70711L11.2929 4.73836L12.7071 3.32414L9.67586 0.292893L8.26164 1.70711ZM7.96875 1V4.03125H9.96875V1H7.96875ZM8.96875 5.03125H12V3.03125H8.96875V5.03125ZM11 4.03125V5H13V4.03125H11ZM1 16H5V14H1V16ZM14 9V12H16V9H14ZM12 13H14V11H12V13ZM14 13H15V11H14V13ZM15 12C15 11.2089 14.7654 10.4355 14.3259 9.77772L12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12H15ZM14.3259 9.77772C13.8864 9.11993 13.2616 8.60723 12.5307 8.30448L11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889L14.3259 9.77772ZM12.5307 8.30448C11.7998 8.00173 10.9956 7.92252 10.2196 8.07686L10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522L12.5307 8.30448ZM10.2196 8.07686C9.44371 8.2312 8.73098 8.61216 8.17157 9.17157L9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384L10.2196 8.07686ZM8.17157 9.17157C7.61216 9.73098 7.2312 10.4437 7.07686 11.2196L9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858L8.17157 9.17157ZM7.07686 11.2196C6.92252 11.9956 7.00173 12.7998 7.30448 13.5307L9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098L7.07686 11.2196ZM7.30448 13.5307C7.60723 14.2616 8.11992 14.8864 8.77772 15.3259L9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654L7.30448 13.5307ZM8.77772 15.3259C9.43552 15.7654 10.2089 16 11 16V14C10.6044 14 10.2178 13.8827 9.88886 13.6629L8.77772 15.3259Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.documents.expired))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.expired.length > 0 &&
                    _vm.documents.needToAdd.length === 0
                      ? _c("div", { staticClass: "summary-documents-hr" })
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.expired.length === 0 &&
                    _vm.documents.needToAdd.length === 0
                      ? _c("div", { staticClass: "summary-documents-empty" }, [
                          _vm._v(" Нет проблем с документами "),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.userHavePermissionUniform()
              ? _c(
                  "div",
                  {
                    staticClass: "summary-uniform",
                    class: {
                      "ml-0":
                        !_vm.userHavePermissionExpiredAndNeedAddDocuments(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "personal-employee-inventory-items",
                        })
                      },
                    },
                  },
                  [
                    _vm.inventory.isLoaded
                      ? _c(
                          "div",
                          { staticClass: "summary-uniform-loader" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length > 0
                      ? _c("div", { staticClass: "summary-uniform-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Не выданы позиции: <b>${_vm.inventory.notIssued}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Не выданы позиции: <b>${inventory.notIssued}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-uniform-item-icon summary-uniform-item-icon-yellow",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "17",
                                    height: "14",
                                    viewBox: "0 0 17 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M10 13H4V5H1V1H5.33333C5.33333 1 6.4 2.5 8 2.5C9.6 2.5 10.6667 1 10.6667 1H15V5H12M10 10H16M16 10L14 8M16 10L14 12",
                                      stroke: "#9FA400",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.inventory.notIssued))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length > 0
                      ? _c("div", { staticClass: "summary-uniform-hr" })
                      : _vm._e(),
                    !_vm.inventory.isLoaded && _vm.inventory.expired.length > 0
                      ? _c("div", { staticClass: "summary-uniform-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Просроченные позиции: <b>${_vm.inventory.expired}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Просроченные позиции: <b>${inventory.expired}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-uniform-item-icon summary-uniform-item-icon-red",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "17",
                                    height: "15",
                                    viewBox: "0 0 17 15",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M5.33333 1L6.14829 0.420476C5.9607 0.15668 5.65703 0 5.33333 0V1ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 5H0C0 5.55228 0.447715 6 1 6L1 5ZM4 5H5C5 4.44772 4.55228 4 4 4V5ZM4 13H3C3 13.5523 3.44771 14 4 14V13ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12V14ZM10.6667 1V0C10.343 0 10.0393 0.15668 9.85171 0.420476L10.6667 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 5V6C15.5523 6 16 5.55228 16 5H15ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6V4ZM17 8C17 7.44771 16.5523 7 16 7C15.4477 7 15 7.44771 15 8H17ZM16 11V12H17V11H16ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V10ZM14.4944 9.33329L15.3259 8.77772L14.4944 9.33329ZM9.87868 8.87868L10.5858 9.58579L9.87868 8.87868ZM9.05764 10.4147L8.07686 10.2196L9.05764 10.4147ZM10.3333 13.4944L9.77772 14.3259L10.3333 13.4944ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM8 1.5C7.51675 1.5 7.06675 1.27078 6.69306 0.970491C6.51259 0.825477 6.36932 0.679038 6.27241 0.570011C6.22447 0.51608 6.1893 0.472912 6.168 0.445861C6.15739 0.432381 6.15034 0.423051 6.14698 0.418557C6.14531 0.416314 6.14457 0.415293 6.14478 0.41558C6.14488 0.415724 6.14523 0.416197 6.14581 0.417009C6.1461 0.417415 6.14645 0.417906 6.14687 0.418483C6.14707 0.418772 6.1473 0.419082 6.14753 0.419415C6.14765 0.41958 6.14784 0.419846 6.1479 0.419929C6.14809 0.4202 6.14829 0.420476 5.33333 1C4.51838 1.57952 4.51858 1.57981 4.51879 1.58011C4.51887 1.58021 4.51908 1.58051 4.51923 1.58072C4.51953 1.58115 4.51985 1.58159 4.52019 1.58206C4.52086 1.583 4.5216 1.58404 4.52241 1.58517C4.52404 1.58742 4.52593 1.59004 4.52811 1.59303C4.53245 1.59899 4.53789 1.60639 4.54442 1.61513C4.55747 1.63261 4.5749 1.65551 4.59658 1.68305C4.63986 1.73803 4.70053 1.81204 4.77759 1.89874C4.93068 2.07096 5.15407 2.29952 5.44027 2.52951C5.99991 2.97922 6.88325 3.5 8 3.5V1.5ZM0 1V5H2V1H0ZM1 6H4V4H1V6ZM3 5V13H5V5H3ZM4 14H6V12H4V14ZM8 3.5C9.11675 3.5 10.0001 2.97922 10.5597 2.52951C10.8459 2.29952 11.0693 2.07096 11.2224 1.89874C11.2995 1.81204 11.3601 1.73803 11.4034 1.68305C11.4251 1.65551 11.4425 1.63261 11.4556 1.61513C11.4621 1.60639 11.4675 1.59899 11.4719 1.59303C11.4741 1.59004 11.476 1.58742 11.4776 1.58517C11.4784 1.58404 11.4791 1.583 11.4798 1.58206C11.4801 1.58159 11.4805 1.58115 11.4808 1.58072C11.4809 1.58051 11.4811 1.58021 11.4812 1.58011C11.4814 1.57981 11.4816 1.57952 10.6667 1C9.85171 0.420476 9.85191 0.4202 9.8521 0.419929C9.85216 0.419846 9.85235 0.41958 9.85247 0.419414C9.8527 0.419082 9.85293 0.418772 9.85313 0.418483C9.85355 0.417906 9.8539 0.417415 9.85419 0.417009C9.85477 0.416197 9.85512 0.415724 9.85522 0.41558C9.85543 0.415293 9.85469 0.416314 9.85302 0.418557C9.84966 0.423051 9.84261 0.432381 9.832 0.445861C9.8107 0.472912 9.77553 0.51608 9.72759 0.570011C9.63068 0.679038 9.4874 0.825477 9.30694 0.970491C8.93325 1.27078 8.48325 1.5 8 1.5V3.5ZM14 1V5H16V1H14ZM15 4H12V6H15V4ZM5.33333 0H1V2H5.33333V0ZM10.6667 2H15V0H10.6667V2ZM15 8V11H17V8H15ZM13 12H15V10H13V12ZM15 12H16V10H15V12ZM16 11C16 10.2089 15.7654 9.43552 15.3259 8.77772L13.6629 9.88886C13.8827 10.2178 14 10.6044 14 11H16ZM15.3259 8.77772C14.8864 8.11993 14.2616 7.60723 13.5307 7.30448L12.7654 9.15224C13.1308 9.30362 13.4432 9.55996 13.6629 9.88886L15.3259 8.77772ZM13.5307 7.30448C12.7998 7.00173 11.9956 6.92252 11.2196 7.07686L11.6098 9.03843C11.9978 8.96126 12.3999 9.00087 12.7654 9.15224L13.5307 7.30448ZM11.2196 7.07686C10.4437 7.2312 9.73098 7.61216 9.17157 8.17157L10.5858 9.58579C10.8655 9.30608 11.2219 9.1156 11.6098 9.03843L11.2196 7.07686ZM9.17157 8.17157C8.61216 8.73098 8.2312 9.44372 8.07686 10.2196L10.0384 10.6098C10.1156 10.2219 10.3061 9.86549 10.5858 9.58579L9.17157 8.17157ZM8.07686 10.2196C7.92252 10.9956 8.00173 11.7998 8.30448 12.5307L10.1522 11.7654C10.0009 11.3999 9.96126 10.9978 10.0384 10.6098L8.07686 10.2196ZM8.30448 12.5307C8.60723 13.2616 9.11992 13.8864 9.77772 14.3259L10.8889 12.6629C10.56 12.4432 10.3036 12.1308 10.1522 11.7654L8.30448 12.5307ZM9.77772 14.3259C10.4355 14.7654 11.2089 15 12 15V13C11.6044 13 11.2178 12.8827 10.8889 12.6629L9.77772 14.3259Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.inventory.expired))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length === 0 &&
                    _vm.inventory.expired.length > 0
                      ? _c("div", { staticClass: "summary-uniform-hr" })
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length === 0 &&
                    _vm.inventory.expired.length === 0
                      ? _c("div", { staticClass: "summary-uniform-empty" }, [
                          _vm._v(" Нет проблем с инвентарем "),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "d-flex" }, [
            _vm.notifications.userHasPermission
              ? _c(
                  "div",
                  { staticClass: "summary-notices" },
                  [
                    _vm.notifications.isLoaded
                      ? _c(
                          "div",
                          { staticClass: "summary-notices-loader" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.notifications.isLoaded
                      ? _c("div", { staticClass: "summary-notices-title" }, [
                          _c(
                            "div",
                            { staticClass: "summary-notices-title-text" },
                            [_vm._v("Уведомления")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "summary-notices-title-count",
                              class: {
                                "summary-notices-title-count-grey":
                                  _vm.notifications.count === 0,
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-notices-title-count-text",
                                },
                                [_vm._v(_vm._s(_vm.notifications.count))]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._l(
                      _vm.notifications.items,
                      function (notification, desktopIndex) {
                        return _c(
                          "div",
                          {
                            key: "notification" + desktopIndex + "desktop",
                            staticClass: "summary-notices-item",
                          },
                          [
                            !_vm.notifications.isLoaded
                              ? [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "summary-notices-item-text",
                                      domProps: {
                                        innerHTML: _vm._s(notification.text),
                                      },
                                    },
                                    [_vm._v(_vm._s(notification.text))]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "summary-notices-item-date",
                                    },
                                    [_vm._v(_vm._s(notification.created))]
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      }
                    ),
                    !_vm.notifications.isLoaded &&
                    _vm.notifications.items.length === 0
                      ? _c("div", { staticClass: "summary-notices-empty" }, [
                          _vm._v(" Нет новых уведомлений "),
                        ])
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "summary-statuses",
                class: {
                  "mt-0":
                    !_vm.userHavePermissionUniform() &&
                    !_vm.userHavePermissionExpiredAndNeedAddDocuments(),
                  "ml-0": !_vm.notifications.userHasPermission,
                },
              },
              [
                _vm.statuses.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-statuses-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.statuses.isLoaded
                  ? _c(
                      "div",
                      {
                        staticClass: "summary-statuses-item",
                        class: {
                          "summary-statuses-item-disabled":
                            _vm.statuses.changeStatusForm.length > 0 &&
                            _vm.statuses.changeStatusForm !== "workerStatus",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-statuses-item-title" },
                          [_vm._v("Статус сотрудника")]
                        ),
                        _vm.statuses.changeStatusForm !== "workerStatus"
                          ? _c(
                              "div",
                              { staticClass: "summary-statuses-item-value" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "summary-statuses-item-text",
                                    class: {
                                      "summary-statuses-item-value-text-not-chosen":
                                        _vm.statuses.characteristic ===
                                        "Не выбрано",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.statuses.workerStatus) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.userHavePermissionChangeWorkerStatuses
                                  ? _c("c-button", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            container: "#app",
                                            trigger: "hover blur",
                                            content: "Редактировать",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Редактировать',\n                  placement: 'top',\n                }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "summary-statuses-item-value-icon",
                                      attrs: { size: "iconic", icon: "edit" },
                                      on: {
                                        click: function ($event) {
                                          _vm.statuses.changeStatusForm =
                                            "workerStatus"
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "summary-statuses-item-value align-items-start w-100",
                              },
                              [
                                _c("c-input", {
                                  staticClass:
                                    "flex-grow-1 summary-statuses-item-value-input",
                                  attrs: {
                                    type: "select",
                                    searchable: true,
                                    items: _vm.statuses.workerStatusLocalItem,
                                  },
                                  model: {
                                    value: _vm.statuses.workerStatusLocal,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.statuses,
                                        "workerStatusLocal",
                                        $$v
                                      )
                                    },
                                    expression: "statuses.workerStatusLocal",
                                  },
                                }),
                                _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        content: "Отменить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  key: "workerStatus1",
                                  staticClass:
                                    "summary-statuses-item-value-close-icon",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "close", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.statuses.changeStatusForm = ""
                                    },
                                  },
                                }),
                                _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        content: "Сохранить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Сохранить',\n                  placement: 'top',\n                }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  key: "workerStatus2",
                                  staticClass:
                                    "summary-statuses-item-value-apply-icon",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "check", color: "success" },
                                  },
                                  on: { click: _vm.changeStatuses },
                                }),
                              ],
                              1
                            ),
                      ]
                    )
                  : _vm._e(),
                !_vm.statuses.isLoaded && _vm.userHavePermissionCharacteristic()
                  ? _c(
                      "div",
                      {
                        staticClass: "summary-statuses-item",
                        class: {
                          "summary-statuses-item-disabled":
                            _vm.statuses.changeStatusForm.length > 0 &&
                            _vm.statuses.changeStatusForm !== "characteristic",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-statuses-item-title" },
                          [_vm._v("Характеристика")]
                        ),
                        _vm.statuses.changeStatusForm !== "characteristic"
                          ? _c(
                              "div",
                              { staticClass: "summary-statuses-item-value" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "summary-statuses-item-text",
                                    class: {
                                      "summary-statuses-item-value-text-not-chosen":
                                        _vm.statuses.characteristic ===
                                        "Не выбрано",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.statuses.characteristic) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.statuses.rankInfo !== null
                                  ? _c("c-rank-info-icon", {
                                      staticClass:
                                        "summary-statuses-item-rankinfo-icon",
                                      attrs: {
                                        "icon-key": "rankinfo-summary-desktop",
                                        data: {
                                          action: _vm.statuses.rankInfo.action,
                                          value: _vm.statuses.rankInfo.value,
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.userHavePermissionChangeWorkerStatuses()
                                  ? _c("c-button", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            container: "#app",
                                            trigger: "hover blur",
                                            content: "Редактировать",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Редактировать',\n                  placement: 'top',\n                }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "summary-statuses-item-value-icon",
                                      attrs: { size: "iconic", icon: "edit" },
                                      on: {
                                        click: function ($event) {
                                          _vm.statuses.changeStatusForm =
                                            "characteristic"
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "summary-statuses-item-value align-items-start w-100",
                              },
                              [
                                _c("c-input", {
                                  staticClass:
                                    "flex-grow-1 summary-statuses-item-value-input",
                                  attrs: {
                                    type: "select",
                                    searchable: true,
                                    items:
                                      _vm.statuses.characteristicLocalItems,
                                  },
                                  model: {
                                    value:
                                      _vm.statuses.characteristicLocalValue,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.statuses,
                                        "characteristicLocalValue",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "statuses.characteristicLocalValue",
                                  },
                                }),
                                _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        content: "Отменить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  key: "workerStatus1",
                                  staticClass:
                                    "summary-statuses-item-value-close-icon",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "close", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.statuses.changeStatusForm = ""
                                    },
                                  },
                                }),
                                _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        content: "Сохранить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Сохранить',\n                  placement: 'top',\n                }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  key: "workerStatus2",
                                  staticClass:
                                    "summary-statuses-item-value-apply-icon",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "check", color: "success" },
                                  },
                                  on: { click: _vm.changeStatuses },
                                }),
                              ],
                              1
                            ),
                      ]
                    )
                  : _vm._e(),
                !_vm.statuses.isLoaded
                  ? _c(
                      "div",
                      {
                        staticClass: "summary-statuses-item",
                        class: {
                          "summary-statuses-item-disabled":
                            _vm.statuses.changeStatusForm.length > 0 &&
                            _vm.statuses.changeStatusForm !==
                              "employmentStatus",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "summary-statuses-item-title" },
                          [_vm._v("Статус трудоустройства")]
                        ),
                        _vm.statuses.changeStatusForm !== "employmentStatus"
                          ? _c(
                              "div",
                              { staticClass: "summary-statuses-item-value" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "summary-statuses-item-text",
                                    class: {
                                      "summary-statuses-item-value-text-not-chosen":
                                        _vm.statuses.employmentStatus ===
                                        "Не выбрано",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.statuses.employmentStatus) +
                                        " "
                                    ),
                                  ]
                                ),
                                _vm.userHavePermissionChangeWorkerStatuses()
                                  ? _c("c-button", {
                                      directives: [
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            container: "#app",
                                            trigger: "hover blur",
                                            content: "Редактировать",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Редактировать',\n                  placement: 'top',\n                }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "summary-statuses-item-value-icon",
                                      attrs: { size: "iconic", icon: "edit" },
                                      on: {
                                        click: function ($event) {
                                          _vm.statuses.changeStatusForm =
                                            "employmentStatus"
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "summary-statuses-item-value align-items-start w-100",
                              },
                              [
                                _c("c-input", {
                                  staticClass:
                                    "flex-grow-1 summary-statuses-item-value-input",
                                  attrs: {
                                    type: "select",
                                    searchable: true,
                                    items:
                                      _vm.statuses.employmentStatusLocalItems,
                                  },
                                  model: {
                                    value:
                                      _vm.statuses.employmentStatusLocalValue,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.statuses,
                                        "employmentStatusLocalValue",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "statuses.employmentStatusLocalValue",
                                  },
                                }),
                                _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        content: "Отменить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  key: "workerStatus1",
                                  staticClass:
                                    "summary-statuses-item-value-close-icon",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "close", color: "secondary" },
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.statuses.changeStatusForm = ""
                                    },
                                  },
                                }),
                                _c("c-button", {
                                  directives: [
                                    {
                                      name: "b-popover",
                                      rawName: "v-b-popover.html",
                                      value: {
                                        container: "#app",
                                        trigger: "hover blur",
                                        content: "Сохранить",
                                        placement: "top",
                                      },
                                      expression:
                                        "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Сохранить',\n                  placement: 'top',\n                }",
                                      modifiers: { html: true },
                                    },
                                  ],
                                  key: "workerStatus2",
                                  staticClass:
                                    "summary-statuses-item-value-apply-icon",
                                  attrs: {
                                    size: "iconic",
                                    icon: { icon: "check", color: "success" },
                                  },
                                  on: { click: _vm.changeStatuses },
                                }),
                              ],
                              1
                            ),
                      ]
                    )
                  : _vm._e(),
                !_vm.statuses.isLoaded
                  ? _c(
                      "div",
                      {
                        staticClass: "summary-statuses-additions",
                        class: {
                          "summary-statuses-additions-disabled":
                            _vm.statuses.changeStatusForm ===
                              "characteristic" ||
                            _vm.statuses.changeStatusForm ===
                              "employmentStatus" ||
                            _vm.statuses.changeStatusForm === "workerStatus",
                        },
                      },
                      [
                        _vm.statuses.combinationFilials
                          ? _c(
                              "div",
                              {
                                staticClass: "summary-statuses-additions-item",
                              },
                              [
                                _c("c-button", {
                                  attrs: { icon: "point", size: "iconic" },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-statuses-additions-item-text",
                                  },
                                  [
                                    _vm._v(
                                      "Может работать в нескольких филиалах"
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.statuses.remoteJob
                          ? _c(
                              "div",
                              {
                                staticClass: "summary-statuses-additions-item",
                              },
                              [
                                _c("c-button", {
                                  attrs: { icon: "home", size: "iconic" },
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-statuses-additions-item-text",
                                  },
                                  [_vm._v("Может работать удалённо")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "summary-container-tablet" }, [
        _vm.userHavePermissionMainFactors()
          ? _c(
              "div",
              { staticClass: "summary-general" },
              [
                _vm.general.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-general-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("div", { staticClass: "summary-general-title" }, [
                      _vm._v("Основные показатели"),
                    ])
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("c-switcher", {
                      staticClass: "summary-general-tabs",
                      attrs: {
                        type: "group",
                        items: [
                          { label: "Сегодня", value: "today" },
                          { label: "Неделя", value: "sunday" },
                          { label: "Текущий месяц", value: "currentMonth" },
                          { label: "Прошлый месяц", value: "previousMonth" },
                        ],
                      },
                      model: {
                        value: _vm.general.tabsLocal,
                        callback: function ($$v) {
                          _vm.$set(_vm.general, "tabsLocal", $$v)
                        },
                        expression: "general.tabsLocal",
                      },
                    })
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("div", { staticClass: "summary-general-main" }, [
                      _c(
                        "div",
                        { staticClass: "summary-general-main-salary" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-main-salary-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].salary
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-main-salary-month",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.general[_vm.general.tabsLocal].interval
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-general-main-additionally" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "summary-general-main-additionally-item",
                            },
                            [
                              _c("c-button", {
                                staticClass:
                                  "summary-general-main-additionally-item-icon",
                                attrs: { size: "iconic", icon: "time" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-main-additionally-item-text",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal]
                                          .hoursWorked
                                      ) +
                                      " / " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal]
                                          .daysWorked
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "summary-general-main-additionally-item",
                            },
                            [
                              _c("c-button", {
                                staticClass:
                                  "summary-general-main-additionally-item-icon",
                                attrs: { size: "iconic", icon: "point" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-main-additionally-item-text",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.general[_vm.general.tabsLocal].point
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("div", { staticClass: "summary-general-money" }, [
                      _c("div", { staticClass: "summary-general-money-item" }, [
                        _c(
                          "div",
                          { staticClass: "summary-general-money-item-amount" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.general[_vm.general.tabsLocal].money
                                      .main.amount
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.currencyLabel) +
                                " "
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "summary-general-money-item-title" },
                          [_vm._v("Основная часть")]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-green":
                              _vm.general[_vm.general.tabsLocal].money.variable
                                .amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money.variable
                                .amount === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .variable.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Переменная часть")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-red":
                              _vm.general[_vm.general.tabsLocal].money.depremal
                                .amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money.depremal
                                .amount === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .depremal.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Депрем-е")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-green":
                              _vm.general[_vm.general.tabsLocal].money
                                .encouragement.amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money
                                .encouragement.amount === 0,
                          },
                        },
                        [
                          _vm.general[_vm.general.tabsLocal].money.encouragement
                            .count > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-money-item-count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal].money
                                          .encouragement.count
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .encouragement.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Поощрения")]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-red":
                              _vm.general[_vm.general.tabsLocal].money.fines
                                .amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money.fines
                                .amount === 0,
                          },
                        },
                        [
                          _vm.general[_vm.general.tabsLocal].money.fines.count >
                          0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-money-item-count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal].money
                                          .fines.count
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .fines.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Штрафы")]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _c("div", { staticClass: "summary-money" }, [
          _vm.money.isLoaded
            ? _c(
                "div",
                { staticClass: "summary-money-loader" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.icon, spin: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.money.isLoaded
            ? _c(
                "div",
                {
                  staticClass: "summary-money-item summary-money-item-yellow",
                  class: {
                    "summary-money-item-yellow":
                      _vm.money.depositLocalValue > 0 &&
                      _vm.money.depositLocalValue <= 1000,
                    "summary-money-item-green":
                      _vm.money.depositLocalValue === 3000,
                    "summary-money-item-red":
                      _vm.money.depositLocalValue <= 0 ||
                      _vm.money.depositLocalValue > 3000,
                    "summary-money-item-clickable":
                      _vm.userHavePermissionUpdateWorkerDeposit(),
                  },
                  on: { click: _vm.showDepositModal },
                },
                [
                  _c("div", { staticClass: "summary-money-item-title" }, [
                    _vm._v("Депозит"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "summary-money-item-amount" },
                    [
                      _c(
                        "div",
                        { staticClass: "summary-money-item-amount-text" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatAmount(_vm.money.depositLocalValue)
                              ) +
                              " " +
                              _vm._s(_vm.currencyLabel) +
                              " "
                          ),
                        ]
                      ),
                      _vm.userHavePermissionUpdateWorkerDeposit()
                        ? _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Редактировать",
                                  placement: "top",
                                },
                                expression:
                                  "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass: "summary-money-item-amount-edit",
                            attrs: { icon: "edit", size: "iconic" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          !_vm.money.isLoaded
            ? _c(
                "div",
                {
                  staticClass: "summary-money-item",
                  class: {
                    "summary-money-item-green":
                      _vm.money.personalAccountValue > 0,
                    "summary-money-item-red":
                      _vm.money.personalAccountValue < 0,
                    "summary-money-item-clickable":
                      _vm.userHavePermissionUpdatePersonalAmount(),
                  },
                  on: {
                    click: function ($event) {
                      _vm.userHavePermissionUpdatePersonalAmount()
                        ? _vm.$refs.typeModal.open()
                        : ""
                    },
                  },
                },
                [
                  _c("div", { staticClass: "summary-money-item-title" }, [
                    _vm._v("Личный счёт"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "summary-money-item-amount" },
                    [
                      _c(
                        "div",
                        { staticClass: "summary-money-item-amount-text" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatAmountWithNegative(
                                  _vm.money.personalAccountValue
                                )
                              ) +
                              " " +
                              _vm._s(_vm.currencyLabel) +
                              " "
                          ),
                        ]
                      ),
                      _vm.userHavePermissionUpdatePersonalAmount()
                        ? _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Редактировать",
                                  placement: "top",
                                },
                                expression:
                                  "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass: "summary-money-item-amount-edit",
                            attrs: { icon: "edit", size: "iconic" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          !_vm.money.isLoaded
            ? _c("div", { staticClass: "summary-money-item" }, [
                _c("div", { staticClass: "summary-money-item-title" }, [
                  _vm._v("Прем. счет"),
                ]),
                _c("div", { staticClass: "summary-money-item-amount" }, [
                  _c("div", { staticClass: "summary-money-item-amount-text" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.formatAmountWithNegative(
                            _vm.money.premiumAccountValue
                          )
                        ) +
                        " " +
                        _vm._s(_vm.currencyLabel) +
                        " "
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
        _c("div", { staticClass: "d-flex w-100" }, [
          _vm.userHavePermissionFinesAndEncourage()
            ? _c(
                "div",
                {
                  staticClass: "summary-encourage",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({
                        name: "personal-employee-discipline",
                      })
                    },
                  },
                },
                [
                  _vm.encourageIsLoaded
                    ? _c(
                        "div",
                        { staticClass: "summary-encourage-loader" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.icon, spin: "" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.encourageIsLoaded
                    ? _c("div", { staticClass: "summary-encourage-title" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "15",
                              viewBox: "0 0 14 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M4.04837 13.1935H2.21935C1.89596 13.1935 1.58581 13.065 1.35714 12.8363C1.12847 12.6077 1 12.2975 1 11.9741V7.70642C1 7.38302 1.12847 7.07288 1.35714 6.84421C1.58581 6.61553 1.89596 6.48707 2.21935 6.48707H4.04837M8.31609 5.26772V2.82902C8.31609 2.34394 8.12339 1.87872 7.78038 1.53571C7.43737 1.1927 6.97215 1 6.48707 1L4.04837 6.48707V13.1935H10.9255C11.2196 13.1968 11.5049 13.0937 11.729 12.9033C11.9531 12.7128 12.1007 12.4478 12.1448 12.157L12.9862 6.66997C13.0127 6.49521 13.0009 6.31677 12.9516 6.14702C12.9024 5.97727 12.8168 5.82026 12.7008 5.68688C12.5848 5.55349 12.4412 5.44692 12.2799 5.37454C12.1187 5.30217 11.9436 5.26572 11.7668 5.26772H8.31609Z",
                                stroke: "#12C971",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "summary-encourage-title-text" },
                          [_vm._v("Поощрения")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.encourageLocalItems, function (item, i) {
                    return _c(
                      "div",
                      {
                        key: `encourage-i-${i}-${item.name}`,
                        staticClass: "summary-encourage-item",
                      },
                      [
                        !_vm.encourageIsLoaded
                          ? [
                              _c(
                                "div",
                                { staticClass: "summary-encourage-item-text" },
                                [_vm._v(_vm._s(item.name))]
                              ),
                              _c(
                                "div",
                                { staticClass: "summary-encourage-item-date" },
                                [_vm._v(_vm._s(item.date))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  !_vm.encourageIsLoaded && _vm.encourageLocalItems.length === 0
                    ? _c("div", { staticClass: "summary-encourage-empty" }, [
                        _vm._v(" Поощрений пока нет "),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm.userHavePermissionFinesAndEncourage()
            ? _c(
                "div",
                {
                  staticClass: "summary-fines",
                  on: {
                    click: function ($event) {
                      return _vm.$router.push({
                        name: "personal-employee-discipline",
                      })
                    },
                  },
                },
                [
                  _vm.finesIsLoaded
                    ? _c(
                        "div",
                        { staticClass: "summary-fines-loader" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.icon, spin: "" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.finesIsLoaded
                    ? _c("div", { staticClass: "summary-fines-title" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "14",
                              height: "15",
                              viewBox: "0 0 14 15",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M4.04837 1.06457H2.21935C1.89596 1.06457 1.58581 1.19304 1.35714 1.42171C1.12847 1.65039 1 1.96053 1 2.28392V6.55164C1 6.87503 1.12847 7.18518 1.35714 7.41385C1.58581 7.64252 1.89596 7.77099 2.21935 7.77099H4.04837M8.31609 8.99034V11.429C8.31609 11.9141 8.12339 12.3793 7.78038 12.7223C7.43737 13.0654 6.97215 13.2581 6.48707 13.2581L4.04837 7.77099V1.06457H10.9255C11.2196 1.06125 11.5049 1.16431 11.729 1.35478C11.9531 1.54524 12.1007 1.81026 12.1448 2.10102L12.9862 7.58809C13.0127 7.76285 13.0009 7.94128 12.9516 8.11103C12.9024 8.28079 12.8168 8.43779 12.7008 8.57118C12.5848 8.70456 12.4412 8.81114 12.2799 8.88351C12.1187 8.95589 11.9436 8.99234 11.7668 8.99034H8.31609Z",
                                stroke: "#FF238D",
                                "stroke-width": "2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                              },
                            }),
                          ]
                        ),
                        _c("div", { staticClass: "summary-fines-title-text" }, [
                          _vm._v("Частые нарушения"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._l(_vm.finesLocalItems, function (fine) {
                    return _c(
                      "div",
                      {
                        key: `fine-i-${fine.name}`,
                        staticClass: "summary-fines-item",
                      },
                      [
                        !_vm.finesIsLoaded
                          ? [
                              _c(
                                "div",
                                { staticClass: "summary-fines-item-text" },
                                [_vm._v(_vm._s(fine.name))]
                              ),
                              _c(
                                "div",
                                { staticClass: "summary-fines-item-count" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "summary-fines-item-count-text",
                                    },
                                    [_vm._v(_vm._s(fine.count))]
                                  ),
                                ]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                  !_vm.finesIsLoaded && _vm.finesLocalItems.length === 0
                    ? _c("div", { staticClass: "summary-fines-empty" }, [
                        _vm._v(" Нарушений пока нет "),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c("div", { staticClass: "d-flex flex-column w-100" }, [
            _vm.userHavePermissionExpiredAndNeedAddDocuments()
              ? _c(
                  "div",
                  {
                    staticClass: "summary-documents",
                    class: {
                      "ml-0": !_vm.userHavePermissionFinesAndEncourage(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "personal-employee-documents",
                        })
                      },
                    },
                  },
                  [
                    _vm.documents.isLoaded
                      ? _c(
                          "div",
                          { staticClass: "summary-documents-loader" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.needToAdd.length > 0
                      ? _c("div", { staticClass: "summary-documents-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Необходимо добавить обязательные документы: <b>${_vm.documents.needToAdd}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Необходимо добавить обязательные документы: <b>${documents.needToAdd}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-documents-item-icon summary-documents-item-icon-yellow",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M8.96875 1H1V15H7M8.96875 1L12 4.03125M8.96875 1V4.03125H12M12 4.03125V5M9 12H12M12 12H15M12 12V9M12 12V15",
                                      stroke: "#9FA400",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.documents.needToAdd))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.needToAdd.length > 0
                      ? _c("div", { staticClass: "summary-documents-hr" })
                      : _vm._e(),
                    !_vm.documents.isLoaded && _vm.documents.expired.length > 0
                      ? _c("div", { staticClass: "summary-documents-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Истёк срок годности у документов: <b>${_vm.documents.expired}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Истёк срок годности у документов: <b>${documents.expired}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-documents-item-icon summary-documents-item-icon-red",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM8.96875 1L9.67586 0.292893L9.38296 0H8.96875V1ZM12 4.03125H13V3.61704L12.7071 3.32414L12 4.03125ZM8.96875 4.03125H7.96875V5.03125H8.96875V4.03125ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14V16ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9H16ZM15 12V13H16V12H15ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13V11ZM13.4944 10.3333L14.3259 9.77772L13.4944 10.3333ZM10.4147 9.05765L10.2196 8.07686L10.4147 9.05765ZM8.87868 9.87868L9.58579 10.5858L8.87868 9.87868ZM8.05765 11.4147L7.07686 11.2196L8.05765 11.4147ZM9.33329 14.4944L8.77772 15.3259L9.33329 14.4944ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM0 1V15H2V1H0ZM8.96875 0H1V2H8.96875V0ZM8.26164 1.70711L11.2929 4.73836L12.7071 3.32414L9.67586 0.292893L8.26164 1.70711ZM7.96875 1V4.03125H9.96875V1H7.96875ZM8.96875 5.03125H12V3.03125H8.96875V5.03125ZM11 4.03125V5H13V4.03125H11ZM1 16H5V14H1V16ZM14 9V12H16V9H14ZM12 13H14V11H12V13ZM14 13H15V11H14V13ZM15 12C15 11.2089 14.7654 10.4355 14.3259 9.77772L12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12H15ZM14.3259 9.77772C13.8864 9.11993 13.2616 8.60723 12.5307 8.30448L11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889L14.3259 9.77772ZM12.5307 8.30448C11.7998 8.00173 10.9956 7.92252 10.2196 8.07686L10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522L12.5307 8.30448ZM10.2196 8.07686C9.44371 8.2312 8.73098 8.61216 8.17157 9.17157L9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384L10.2196 8.07686ZM8.17157 9.17157C7.61216 9.73098 7.2312 10.4437 7.07686 11.2196L9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858L8.17157 9.17157ZM7.07686 11.2196C6.92252 11.9956 7.00173 12.7998 7.30448 13.5307L9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098L7.07686 11.2196ZM7.30448 13.5307C7.60723 14.2616 8.11992 14.8864 8.77772 15.3259L9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654L7.30448 13.5307ZM8.77772 15.3259C9.43552 15.7654 10.2089 16 11 16V14C10.6044 14 10.2178 13.8827 9.88886 13.6629L8.77772 15.3259Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.documents.expired))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.expired.length > 0 &&
                    _vm.documents.needToAdd.length === 0
                      ? _c("div", { staticClass: "summary-documents-hr" })
                      : _vm._e(),
                    !_vm.documents.isLoaded &&
                    _vm.documents.expired.length === 0 &&
                    _vm.documents.needToAdd.length === 0
                      ? _c("div", { staticClass: "summary-documents-empty" }, [
                          _vm._v(" Нет проблем с документами "),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm.userHavePermissionUniform()
              ? _c(
                  "div",
                  {
                    staticClass: "summary-uniform",
                    class: {
                      "ml-0": !_vm.userHavePermissionFinesAndEncourage(),
                      "mt-0":
                        !_vm.userHavePermissionExpiredAndNeedAddDocuments(),
                    },
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({
                          name: "personal-employee-inventory-items",
                        })
                      },
                    },
                  },
                  [
                    _vm.inventory.isLoaded
                      ? _c(
                          "div",
                          { staticClass: "summary-uniform-loader" },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: _vm.icon, spin: "" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length > 0
                      ? _c("div", { staticClass: "summary-uniform-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Не выданы позиции: <b>${_vm.inventory.notIssued}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Не выданы позиции: <b>${inventory.notIssued}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-uniform-item-icon summary-uniform-item-icon-yellow",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "17",
                                    height: "14",
                                    viewBox: "0 0 17 14",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M10 13H4V5H1V1H5.33333C5.33333 1 6.4 2.5 8 2.5C9.6 2.5 10.6667 1 10.6667 1H15V5H12M10 10H16M16 10L14 8M16 10L14 12",
                                      stroke: "#9FA400",
                                      "stroke-width": "2",
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.inventory.notIssued))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length > 0
                      ? _c("div", { staticClass: "summary-uniform-hr" })
                      : _vm._e(),
                    !_vm.inventory.isLoaded && _vm.inventory.expired.length > 0
                      ? _c("div", { staticClass: "summary-uniform-item" }, [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "hover blur",
                                    content: `Просроченные позиции: <b>${_vm.inventory.expired}</b>`,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: `Просроченные позиции: <b>${inventory.expired}</b>`,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "summary-uniform-item-icon summary-uniform-item-icon-red",
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "17",
                                    height: "15",
                                    viewBox: "0 0 17 15",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M5.33333 1L6.14829 0.420476C5.9607 0.15668 5.65703 0 5.33333 0V1ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 5H0C0 5.55228 0.447715 6 1 6L1 5ZM4 5H5C5 4.44772 4.55228 4 4 4V5ZM4 13H3C3 13.5523 3.44771 14 4 14V13ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12V14ZM10.6667 1V0C10.343 0 10.0393 0.15668 9.85171 0.420476L10.6667 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 5V6C15.5523 6 16 5.55228 16 5H15ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6V4ZM17 8C17 7.44771 16.5523 7 16 7C15.4477 7 15 7.44771 15 8H17ZM16 11V12H17V11H16ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V10ZM14.4944 9.33329L15.3259 8.77772L14.4944 9.33329ZM9.87868 8.87868L10.5858 9.58579L9.87868 8.87868ZM9.05764 10.4147L8.07686 10.2196L9.05764 10.4147ZM10.3333 13.4944L9.77772 14.3259L10.3333 13.4944ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM8 1.5C7.51675 1.5 7.06675 1.27078 6.69306 0.970491C6.51259 0.825477 6.36932 0.679038 6.27241 0.570011C6.22447 0.51608 6.1893 0.472912 6.168 0.445861C6.15739 0.432381 6.15034 0.423051 6.14698 0.418557C6.14531 0.416314 6.14457 0.415293 6.14478 0.41558C6.14488 0.415724 6.14523 0.416197 6.14581 0.417009C6.1461 0.417415 6.14645 0.417906 6.14687 0.418483C6.14707 0.418772 6.1473 0.419082 6.14753 0.419415C6.14765 0.41958 6.14784 0.419846 6.1479 0.419929C6.14809 0.4202 6.14829 0.420476 5.33333 1C4.51838 1.57952 4.51858 1.57981 4.51879 1.58011C4.51887 1.58021 4.51908 1.58051 4.51923 1.58072C4.51953 1.58115 4.51985 1.58159 4.52019 1.58206C4.52086 1.583 4.5216 1.58404 4.52241 1.58517C4.52404 1.58742 4.52593 1.59004 4.52811 1.59303C4.53245 1.59899 4.53789 1.60639 4.54442 1.61513C4.55747 1.63261 4.5749 1.65551 4.59658 1.68305C4.63986 1.73803 4.70053 1.81204 4.77759 1.89874C4.93068 2.07096 5.15407 2.29952 5.44027 2.52951C5.99991 2.97922 6.88325 3.5 8 3.5V1.5ZM0 1V5H2V1H0ZM1 6H4V4H1V6ZM3 5V13H5V5H3ZM4 14H6V12H4V14ZM8 3.5C9.11675 3.5 10.0001 2.97922 10.5597 2.52951C10.8459 2.29952 11.0693 2.07096 11.2224 1.89874C11.2995 1.81204 11.3601 1.73803 11.4034 1.68305C11.4251 1.65551 11.4425 1.63261 11.4556 1.61513C11.4621 1.60639 11.4675 1.59899 11.4719 1.59303C11.4741 1.59004 11.476 1.58742 11.4776 1.58517C11.4784 1.58404 11.4791 1.583 11.4798 1.58206C11.4801 1.58159 11.4805 1.58115 11.4808 1.58072C11.4809 1.58051 11.4811 1.58021 11.4812 1.58011C11.4814 1.57981 11.4816 1.57952 10.6667 1C9.85171 0.420476 9.85191 0.4202 9.8521 0.419929C9.85216 0.419846 9.85235 0.41958 9.85247 0.419414C9.8527 0.419082 9.85293 0.418772 9.85313 0.418483C9.85355 0.417906 9.8539 0.417415 9.85419 0.417009C9.85477 0.416197 9.85512 0.415724 9.85522 0.41558C9.85543 0.415293 9.85469 0.416314 9.85302 0.418557C9.84966 0.423051 9.84261 0.432381 9.832 0.445861C9.8107 0.472912 9.77553 0.51608 9.72759 0.570011C9.63068 0.679038 9.4874 0.825477 9.30694 0.970491C8.93325 1.27078 8.48325 1.5 8 1.5V3.5ZM14 1V5H16V1H14ZM15 4H12V6H15V4ZM5.33333 0H1V2H5.33333V0ZM10.6667 2H15V0H10.6667V2ZM15 8V11H17V8H15ZM13 12H15V10H13V12ZM15 12H16V10H15V12ZM16 11C16 10.2089 15.7654 9.43552 15.3259 8.77772L13.6629 9.88886C13.8827 10.2178 14 10.6044 14 11H16ZM15.3259 8.77772C14.8864 8.11993 14.2616 7.60723 13.5307 7.30448L12.7654 9.15224C13.1308 9.30362 13.4432 9.55996 13.6629 9.88886L15.3259 8.77772ZM13.5307 7.30448C12.7998 7.00173 11.9956 6.92252 11.2196 7.07686L11.6098 9.03843C11.9978 8.96126 12.3999 9.00087 12.7654 9.15224L13.5307 7.30448ZM11.2196 7.07686C10.4437 7.2312 9.73098 7.61216 9.17157 8.17157L10.5858 9.58579C10.8655 9.30608 11.2219 9.1156 11.6098 9.03843L11.2196 7.07686ZM9.17157 8.17157C8.61216 8.73098 8.2312 9.44372 8.07686 10.2196L10.0384 10.6098C10.1156 10.2219 10.3061 9.86549 10.5858 9.58579L9.17157 8.17157ZM8.07686 10.2196C7.92252 10.9956 8.00173 11.7998 8.30448 12.5307L10.1522 11.7654C10.0009 11.3999 9.96126 10.9978 10.0384 10.6098L8.07686 10.2196ZM8.30448 12.5307C8.60723 13.2616 9.11992 13.8864 9.77772 14.3259L10.8889 12.6629C10.56 12.4432 10.3036 12.1308 10.1522 11.7654L8.30448 12.5307ZM9.77772 14.3259C10.4355 14.7654 11.2089 15 12 15V13C11.6044 13 11.2178 12.8827 10.8889 12.6629L9.77772 14.3259Z",
                                      fill: "#FF238D",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "summary-documents-item-text" },
                            [_vm._v(_vm._s(_vm.inventory.expired))]
                          ),
                        ])
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length === 0 &&
                    _vm.inventory.expired.length > 0
                      ? _c("div", { staticClass: "summary-uniform-hr" })
                      : _vm._e(),
                    !_vm.inventory.isLoaded &&
                    _vm.inventory.notIssued.length === 0 &&
                    _vm.inventory.expired.length === 0
                      ? _c("div", { staticClass: "summary-uniform-empty" }, [
                          _vm._v(" Нет проблем с инвентарем "),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "d-flex w-100" }, [
          _vm.notifications.userHasPermission
            ? _c(
                "div",
                { staticClass: "summary-notices" },
                [
                  _vm.notifications.isLoaded
                    ? _c(
                        "div",
                        { staticClass: "summary-notices-loader" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.icon, spin: "" },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.notifications.isLoaded
                    ? _c("div", { staticClass: "summary-notices-title" }, [
                        _c(
                          "div",
                          { staticClass: "summary-notices-title-text" },
                          [_vm._v("Уведомления")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "summary-notices-title-count",
                            class: {
                              "summary-notices-title-count-grey":
                                _vm.notifications.count === 0,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "summary-notices-title-count-text",
                              },
                              [_vm._v(_vm._s(_vm.notifications.count))]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._l(
                    _vm.notifications.items,
                    function (notification, tabletIndex) {
                      return _c(
                        "div",
                        {
                          key: "notification" + tabletIndex + "tablet",
                          staticClass: "summary-notices-item",
                        },
                        [
                          !_vm.notifications.isLoaded
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass: "summary-notices-item-text",
                                    domProps: {
                                      innerHTML: _vm._s(notification.text),
                                    },
                                  },
                                  [_vm._v(_vm._s(notification.text))]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "summary-notices-item-date" },
                                  [_vm._v(_vm._s(notification.created))]
                                ),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }
                  ),
                  !_vm.notifications.isLoaded &&
                  _vm.notifications.items.length === 0
                    ? _c("div", { staticClass: "summary-notices-empty" }, [
                        _vm._v(" Нет новых уведомлений "),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "summary-statuses",
              class: { "ml-0": !_vm.notifications.userHasPermission },
            },
            [
              _vm.statuses.isLoaded
                ? _c(
                    "div",
                    { staticClass: "summary-statuses-loader" },
                    [
                      _c("font-awesome-icon", {
                        attrs: { icon: _vm.icon, spin: "" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              !_vm.statuses.isLoaded
                ? _c(
                    "div",
                    {
                      staticClass: "summary-statuses-item",
                      class: {
                        "summary-statuses-item-disabled":
                          _vm.statuses.changeStatusForm.length > 0 &&
                          _vm.statuses.changeStatusForm !== "workerStatus",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "summary-statuses-item-title" },
                        [_vm._v("Статус сотрудника")]
                      ),
                      _vm.statuses.changeStatusForm !== "workerStatus"
                        ? _c(
                            "div",
                            { staticClass: "summary-statuses-item-value" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "summary-statuses-item-text",
                                  class: {
                                    "summary-statuses-item-value-text-not-chosen":
                                      _vm.statuses.characteristic ===
                                      "Не выбрано",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.statuses.workerStatus) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.userHavePermissionChangeWorkerStatuses
                                ? _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "hover blur",
                                          content: "Редактировать",
                                          placement: "top",
                                        },
                                        expression:
                                          "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Редактировать',\n                placement: 'top',\n              }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    staticClass:
                                      "summary-statuses-item-value-icon",
                                    attrs: { size: "iconic", icon: "edit" },
                                    on: {
                                      click: function ($event) {
                                        _vm.statuses.changeStatusForm =
                                          "workerStatus"
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "summary-statuses-item-value align-items-start w-100",
                            },
                            [
                              _c("c-input", {
                                staticClass:
                                  "flex-grow-1 summary-statuses-item-value-input",
                                attrs: {
                                  type: "select",
                                  searchable: true,
                                  items: _vm.statuses.workerStatusLocalItem,
                                },
                                model: {
                                  value: _vm.statuses.workerStatusLocal,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statuses,
                                      "workerStatusLocal",
                                      $$v
                                    )
                                  },
                                  expression: "statuses.workerStatusLocal",
                                },
                              }),
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Отменить",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                key: "workerStatus1",
                                staticClass:
                                  "summary-statuses-item-value-close-icon",
                                attrs: {
                                  size: "iconic",
                                  icon: { icon: "close", color: "secondary" },
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.statuses.changeStatusForm = ""
                                  },
                                },
                              }),
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Сохранить",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                key: "workerStatus2",
                                staticClass:
                                  "summary-statuses-item-value-apply-icon",
                                attrs: {
                                  size: "iconic",
                                  icon: { icon: "check", color: "success" },
                                },
                                on: { click: _vm.changeStatuses },
                              }),
                            ],
                            1
                          ),
                    ]
                  )
                : _vm._e(),
              !_vm.statuses.isLoaded && _vm.userHavePermissionCharacteristic()
                ? _c(
                    "div",
                    {
                      staticClass: "summary-statuses-item",
                      class: {
                        "summary-statuses-item-disabled":
                          _vm.statuses.changeStatusForm.length > 0 &&
                          _vm.statuses.changeStatusForm !== "characteristic",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "summary-statuses-item-title" },
                        [_vm._v("Характеристика")]
                      ),
                      _vm.statuses.changeStatusForm !== "characteristic"
                        ? _c(
                            "div",
                            { staticClass: "summary-statuses-item-value" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "summary-statuses-item-text",
                                  class: {
                                    "summary-statuses-item-value-text-not-chosen":
                                      _vm.statuses.characteristic ===
                                      "Не выбрано",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.statuses.characteristic) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.statuses.rankInfo !== null
                                ? _c("c-rank-info-icon", {
                                    staticClass:
                                      "summary-statuses-item-rankinfo-icon",
                                    attrs: {
                                      "icon-key": "rankinfo-summary-tablet",
                                      data: {
                                        action: _vm.statuses.rankInfo.action,
                                        value: _vm.statuses.rankInfo.value,
                                      },
                                    },
                                  })
                                : _vm._e(),
                              _vm.userHavePermissionChangeWorkerStatuses()
                                ? _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "hover blur",
                                          content: "Редактировать",
                                          placement: "top",
                                        },
                                        expression:
                                          "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Редактировать',\n                placement: 'top',\n              }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    staticClass:
                                      "summary-statuses-item-value-icon",
                                    attrs: { size: "iconic", icon: "edit" },
                                    on: {
                                      click: function ($event) {
                                        _vm.statuses.changeStatusForm =
                                          "characteristic"
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "summary-statuses-item-value align-items-start w-100",
                            },
                            [
                              _c("c-input", {
                                staticClass:
                                  "flex-grow-1 summary-statuses-item-value-input",
                                attrs: {
                                  type: "select",
                                  searchable: true,
                                  items: _vm.statuses.characteristicLocalItems,
                                },
                                model: {
                                  value: _vm.statuses.characteristicLocalValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statuses,
                                      "characteristicLocalValue",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "statuses.characteristicLocalValue",
                                },
                              }),
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Отменить",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                key: "workerStatus1",
                                staticClass:
                                  "summary-statuses-item-value-close-icon",
                                attrs: {
                                  size: "iconic",
                                  icon: { icon: "close", color: "secondary" },
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.statuses.changeStatusForm = ""
                                  },
                                },
                              }),
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Сохранить",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                key: "workerStatus2",
                                staticClass:
                                  "summary-statuses-item-value-apply-icon",
                                attrs: {
                                  size: "iconic",
                                  icon: { icon: "check", color: "success" },
                                },
                                on: { click: _vm.changeStatuses },
                              }),
                            ],
                            1
                          ),
                    ]
                  )
                : _vm._e(),
              !_vm.statuses.isLoaded
                ? _c(
                    "div",
                    {
                      staticClass: "summary-statuses-item",
                      class: {
                        "summary-statuses-item-disabled":
                          _vm.statuses.changeStatusForm.length > 0 &&
                          _vm.statuses.changeStatusForm !== "employmentStatus",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "summary-statuses-item-title" },
                        [_vm._v("Статус трудоустройства")]
                      ),
                      _vm.statuses.changeStatusForm !== "employmentStatus"
                        ? _c(
                            "div",
                            { staticClass: "summary-statuses-item-value" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "summary-statuses-item-text",
                                  class: {
                                    "summary-statuses-item-value-text-not-chosen":
                                      _vm.statuses.employmentStatus ===
                                      "Не выбрано",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.statuses.employmentStatus) +
                                      " "
                                  ),
                                ]
                              ),
                              _vm.userHavePermissionChangeWorkerStatuses()
                                ? _c("c-button", {
                                    directives: [
                                      {
                                        name: "b-popover",
                                        rawName: "v-b-popover.html",
                                        value: {
                                          container: "#app",
                                          trigger: "hover blur",
                                          content: "Редактировать",
                                          placement: "top",
                                        },
                                        expression:
                                          "{\n                container: '#app',\n                trigger: 'hover blur',\n                content: 'Редактировать',\n                placement: 'top',\n              }",
                                        modifiers: { html: true },
                                      },
                                    ],
                                    staticClass:
                                      "summary-statuses-item-value-icon",
                                    attrs: { size: "iconic", icon: "edit" },
                                    on: {
                                      click: function ($event) {
                                        _vm.statuses.changeStatusForm =
                                          "employmentStatus"
                                      },
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "summary-statuses-item-value align-items-start w-100",
                            },
                            [
                              _c("c-input", {
                                staticClass:
                                  "flex-grow-1 summary-statuses-item-value-input",
                                attrs: {
                                  type: "select",
                                  searchable: true,
                                  items:
                                    _vm.statuses.employmentStatusLocalItems,
                                },
                                model: {
                                  value:
                                    _vm.statuses.employmentStatusLocalValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.statuses,
                                      "employmentStatusLocalValue",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "statuses.employmentStatusLocalValue",
                                },
                              }),
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Отменить",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                key: "workerStatus1",
                                staticClass:
                                  "summary-statuses-item-value-close-icon",
                                attrs: {
                                  size: "iconic",
                                  icon: { icon: "close", color: "secondary" },
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.statuses.changeStatusForm = ""
                                  },
                                },
                              }),
                              _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Сохранить",
                                      placement: "top",
                                    },
                                    expression:
                                      "{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }",
                                    modifiers: { html: true },
                                  },
                                ],
                                key: "workerStatus2",
                                staticClass:
                                  "summary-statuses-item-value-apply-icon",
                                attrs: {
                                  size: "iconic",
                                  icon: { icon: "check", color: "success" },
                                },
                                on: { click: _vm.changeStatuses },
                              }),
                            ],
                            1
                          ),
                    ]
                  )
                : _vm._e(),
              !_vm.statuses.isLoaded
                ? _c(
                    "div",
                    {
                      staticClass: "summary-statuses-additions",
                      class: {
                        "summary-statuses-additions-disabled":
                          _vm.statuses.changeStatusForm === "characteristic" ||
                          _vm.statuses.changeStatusForm ===
                            "employmentStatus" ||
                          _vm.statuses.changeStatusForm === "workerStatus",
                      },
                    },
                    [
                      _vm.statuses.combinationFilials
                        ? _c(
                            "div",
                            { staticClass: "summary-statuses-additions-item" },
                            [
                              _c("c-button", {
                                attrs: { icon: "point", size: "iconic" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-statuses-additions-item-text",
                                },
                                [_vm._v("Может работать в нескольких филиалах")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.statuses.remoteJob
                        ? _c(
                            "div",
                            { staticClass: "summary-statuses-additions-item" },
                            [
                              _c("c-button", {
                                attrs: { icon: "home", size: "iconic" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-statuses-additions-item-text",
                                },
                                [_vm._v("Может работать удалённо")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "summary-container-mobile" }, [
        _c("div", { staticClass: "summary-money" }, [
          _vm.money.isLoaded
            ? _c(
                "div",
                { staticClass: "summary-money-loader" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.icon, spin: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.money.isLoaded
            ? _c(
                "div",
                {
                  staticClass: "summary-money-item summary-money-item-yellow",
                  class: {
                    "summary-money-item-yellow":
                      _vm.money.depositLocalValue > 0 &&
                      _vm.money.depositLocalValue <= 1000,
                    "summary-money-item-green":
                      _vm.money.depositLocalValue === 3000,
                    "summary-money-item-red":
                      _vm.money.depositLocalValue <= 0 ||
                      _vm.money.depositLocalValue > 3000,
                    "summary-money-item-clickable":
                      _vm.userHavePermissionUpdateWorkerDeposit(),
                  },
                  on: {
                    click: function ($event) {
                      _vm.userHavePermissionUpdateWorkerDeposit()
                        ? (_vm.isShowDepositTransactionModal = true)
                        : ""
                      this.$refs.depositModal.open()
                      _vm.console.log("hello;")
                    },
                  },
                },
                [
                  _c("div", { staticClass: "summary-money-item-title" }, [
                    _vm._v("Депозит"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "summary-money-item-amount" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "summary-money-item-amount-text",
                          class: {
                            "summary-money-item-amount-text-no-edit":
                              !_vm.userHavePermissionUpdatePersonalAmount(),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatAmountWithNegative(
                                  _vm.money.depositLocalValue
                                )
                              ) +
                              " " +
                              _vm._s(_vm.currencyLabel) +
                              " "
                          ),
                        ]
                      ),
                      _vm.userHavePermissionUpdateWorkerDeposit()
                        ? _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Редактировать",
                                  placement: "top",
                                },
                                expression:
                                  "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass: "summary-money-item-amount-edit",
                            attrs: { icon: "edit", size: "iconic" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          !_vm.money.isLoaded
            ? _c(
                "div",
                {
                  staticClass:
                    "summary-money-item summary-money-item-clickable",
                  class: {
                    "summary-money-item-green":
                      _vm.money.personalAccountValue > 0,
                    "summary-money-item-red":
                      _vm.money.personalAccountValue < 0,
                    "summary-money-item-clickable":
                      _vm.userHavePermissionUpdatePersonalAmount(),
                  },
                  on: {
                    click: function ($event) {
                      _vm.userHavePermissionUpdatePersonalAmount()
                        ? _vm.$refs.typeModal.open()
                        : ""
                    },
                  },
                },
                [
                  _c("div", { staticClass: "summary-money-item-title" }, [
                    _vm._v("Личный счёт"),
                  ]),
                  _c(
                    "div",
                    { staticClass: "summary-money-item-amount" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "summary-money-item-amount-text",
                          class: {
                            "summary-money-item-amount-text-no-edit":
                              !_vm.userHavePermissionUpdatePersonalAmount(),
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.formatAmountWithNegative(
                                  _vm.money.personalAccountValue
                                )
                              ) +
                              " " +
                              _vm._s(_vm.currencyLabel) +
                              " "
                          ),
                        ]
                      ),
                      _vm.userHavePermissionUpdatePersonalAmount()
                        ? _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Редактировать",
                                  placement: "top",
                                },
                                expression:
                                  "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                modifiers: { html: true },
                              },
                            ],
                            staticClass: "summary-money-item-amount-edit",
                            attrs: { icon: "edit", size: "iconic" },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
          !_vm.money.isLoaded
            ? _c("div", { staticClass: "summary-money-item" }, [
                _c("div", { staticClass: "summary-money-item-title" }, [
                  _vm._v("Прем. счет"),
                ]),
                _c("div", { staticClass: "summary-money-item-amount" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "summary-money-item-amount-text summary-money-item-amount-text-no-edit",
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.formatAmountWithNegative(
                              _vm.money.premiumAccountValue
                            )
                          ) +
                          " " +
                          _vm._s(_vm.currencyLabel) +
                          " "
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]),
        _vm.userHavePermissionMainFactors()
          ? _c(
              "div",
              { staticClass: "summary-general" },
              [
                _vm.general.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-general-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("div", { staticClass: "summary-general-title" }, [
                      _vm._v("Основные показатели"),
                    ])
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("c-switcher", {
                      staticClass: "summary-general-tabs",
                      attrs: {
                        type: "group",
                        items: [
                          { label: "Сегодня", value: "today" },
                          { label: "Неделя", value: "sunday" },
                          { label: "Текущий месяц", value: "currentMonth" },
                          { label: "Прошлый месяц", value: "previousMonth" },
                        ],
                      },
                      model: {
                        value: _vm.general.tabsLocal,
                        callback: function ($$v) {
                          _vm.$set(_vm.general, "tabsLocal", $$v)
                        },
                        expression: "general.tabsLocal",
                      },
                    })
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("div", { staticClass: "summary-general-main" }, [
                      _c(
                        "div",
                        { staticClass: "summary-general-main-salary" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-main-salary-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].salary
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-main-salary-month",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.general[_vm.general.tabsLocal].interval
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-general-main-additionally" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "summary-general-main-additionally-item",
                            },
                            [
                              _c("c-button", {
                                staticClass:
                                  "summary-general-main-additionally-item-icon",
                                attrs: { size: "iconic", icon: "time" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-main-additionally-item-text",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal]
                                          .hoursWorked
                                      ) +
                                      " / " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal]
                                          .daysWorked
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "summary-general-main-additionally-item",
                            },
                            [
                              _c("c-button", {
                                staticClass:
                                  "summary-general-main-additionally-item-icon",
                                attrs: { size: "iconic", icon: "point" },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-main-additionally-item-text",
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.general[_vm.general.tabsLocal].point
                                    )
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                !_vm.general.isLoaded
                  ? _c("div", { staticClass: "summary-general-money" }, [
                      _c("div", { staticClass: "summary-general-money-item" }, [
                        _c(
                          "div",
                          { staticClass: "summary-general-money-item-title" },
                          [_vm._v("Основная часть")]
                        ),
                        _c(
                          "div",
                          { staticClass: "summary-general-money-item-amount" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.formatAmount(
                                    _vm.general[_vm.general.tabsLocal].money
                                      .main.amount
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.currencyLabel) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-green":
                              _vm.general[_vm.general.tabsLocal].money.variable
                                .amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money.variable
                                .amount === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Переменная часть")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .variable.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-red":
                              _vm.general[_vm.general.tabsLocal].money.depremal
                                .amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money.depremal
                                .amount === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Депрем-е")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .depremal.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-green":
                              _vm.general[_vm.general.tabsLocal].money
                                .encouragement.amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money
                                .encouragement.amount === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Поощрения")]
                          ),
                          _vm.general[_vm.general.tabsLocal].money.encouragement
                            .count > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-money-item-count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal].money
                                          .encouragement.count
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .encouragement.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "summary-general-money-item",
                          class: {
                            "summary-general-money-item-red":
                              _vm.general[_vm.general.tabsLocal].money.fines
                                .amount > 0,
                            "summary-general-money-item-gray":
                              _vm.general[_vm.general.tabsLocal].money.fines
                                .amount === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "summary-general-money-item-title" },
                            [_vm._v("Штрафы")]
                          ),
                          _vm.general[_vm.general.tabsLocal].money.fines.count >
                          0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "summary-general-money-item-count",
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.general[_vm.general.tabsLocal].money
                                          .fines.count
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticClass: "summary-general-money-item-amount",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatAmount(
                                      _vm.general[_vm.general.tabsLocal].money
                                        .fines.amount
                                    )
                                  ) +
                                  " " +
                                  _vm._s(_vm.currencyLabel) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm.userHavePermissionExpiredAndNeedAddDocuments()
          ? _c(
              "div",
              {
                staticClass: "summary-documents",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "personal-employee-documents",
                    })
                  },
                },
              },
              [
                _vm.documents.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-documents-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.documents.isLoaded && _vm.documents.needToAdd.length > 0
                  ? _c("div", { staticClass: "summary-documents-item" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover blur",
                                content: `Необходимо добавить обязательные документы: <b>${_vm.documents.needToAdd}</b>`,
                                placement: "top",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: `Необходимо добавить обязательные документы: <b>${documents.needToAdd}</b>`,\n            placement: 'top',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          staticClass:
                            "summary-documents-item-icon summary-documents-item-icon-yellow",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M8.96875 1H1V15H7M8.96875 1L12 4.03125M8.96875 1V4.03125H12M12 4.03125V5M9 12H12M12 12H15M12 12V9M12 12V15",
                                  stroke: "#9FA400",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-documents-item-text" },
                        [_vm._v(_vm._s(_vm.documents.needToAdd))]
                      ),
                    ])
                  : _vm._e(),
                !_vm.documents.isLoaded && _vm.documents.needToAdd.length > 0
                  ? _c("div", { staticClass: "summary-documents-hr" })
                  : _vm._e(),
                !_vm.documents.isLoaded && _vm.documents.expired.length > 0
                  ? _c("div", { staticClass: "summary-documents-item" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover blur",
                                content: `Истёк срок годности у документов: <b>${_vm.documents.expired}</b>`,
                                placement: "top",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: `Истёк срок годности у документов: <b>${documents.expired}</b>`,\n            placement: 'top',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          staticClass:
                            "summary-documents-item-icon summary-documents-item-icon-red",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 15H0C0 15.5523 0.447715 16 1 16L1 15ZM8.96875 1L9.67586 0.292893L9.38296 0H8.96875V1ZM12 4.03125H13V3.61704L12.7071 3.32414L12 4.03125ZM8.96875 4.03125H7.96875V5.03125H8.96875V4.03125ZM11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5H11ZM5 16C5.55228 16 6 15.5523 6 15C6 14.4477 5.55228 14 5 14V16ZM16 9C16 8.44772 15.5523 8 15 8C14.4477 8 14 8.44772 14 9H16ZM15 12V13H16V12H15ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13V11ZM13.4944 10.3333L14.3259 9.77772L13.4944 10.3333ZM10.4147 9.05765L10.2196 8.07686L10.4147 9.05765ZM8.87868 9.87868L9.58579 10.5858L8.87868 9.87868ZM8.05765 11.4147L7.07686 11.2196L8.05765 11.4147ZM9.33329 14.4944L8.77772 15.3259L9.33329 14.4944ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14V16ZM0 1V15H2V1H0ZM8.96875 0H1V2H8.96875V0ZM8.26164 1.70711L11.2929 4.73836L12.7071 3.32414L9.67586 0.292893L8.26164 1.70711ZM7.96875 1V4.03125H9.96875V1H7.96875ZM8.96875 5.03125H12V3.03125H8.96875V5.03125ZM11 4.03125V5H13V4.03125H11ZM1 16H5V14H1V16ZM14 9V12H16V9H14ZM12 13H14V11H12V13ZM14 13H15V11H14V13ZM15 12C15 11.2089 14.7654 10.4355 14.3259 9.77772L12.6629 10.8889C12.8827 11.2178 13 11.6044 13 12H15ZM14.3259 9.77772C13.8864 9.11993 13.2616 8.60723 12.5307 8.30448L11.7654 10.1522C12.1308 10.3036 12.4432 10.56 12.6629 10.8889L14.3259 9.77772ZM12.5307 8.30448C11.7998 8.00173 10.9956 7.92252 10.2196 8.07686L10.6098 10.0384C10.9978 9.96126 11.3999 10.0009 11.7654 10.1522L12.5307 8.30448ZM10.2196 8.07686C9.44371 8.2312 8.73098 8.61216 8.17157 9.17157L9.58579 10.5858C9.86549 10.3061 10.2219 10.1156 10.6098 10.0384L10.2196 8.07686ZM8.17157 9.17157C7.61216 9.73098 7.2312 10.4437 7.07686 11.2196L9.03843 11.6098C9.1156 11.2219 9.30608 10.8655 9.58579 10.5858L8.17157 9.17157ZM7.07686 11.2196C6.92252 11.9956 7.00173 12.7998 7.30448 13.5307L9.15224 12.7654C9.00087 12.3999 8.96126 11.9978 9.03843 11.6098L7.07686 11.2196ZM7.30448 13.5307C7.60723 14.2616 8.11992 14.8864 8.77772 15.3259L9.88886 13.6629C9.55996 13.4432 9.30362 13.1308 9.15224 12.7654L7.30448 13.5307ZM8.77772 15.3259C9.43552 15.7654 10.2089 16 11 16V14C10.6044 14 10.2178 13.8827 9.88886 13.6629L8.77772 15.3259Z",
                                  fill: "#FF238D",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-documents-item-text" },
                        [_vm._v(_vm._s(_vm.documents.expired))]
                      ),
                    ])
                  : _vm._e(),
                !_vm.documents.isLoaded &&
                _vm.documents.expired.length > 0 &&
                _vm.documents.needToAdd.length === 0
                  ? _c("div", { staticClass: "summary-documents-hr" })
                  : _vm._e(),
                !_vm.documents.isLoaded &&
                _vm.documents.expired.length === 0 &&
                _vm.documents.needToAdd.length === 0
                  ? _c("div", { staticClass: "summary-documents-empty" }, [
                      _vm._v(" Нет проблем с документами "),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm.userHavePermissionUniform()
          ? _c(
              "div",
              {
                staticClass: "summary-uniform",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "personal-employee-inventory-items",
                    })
                  },
                },
              },
              [
                _vm.inventory.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-uniform-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.inventory.isLoaded && _vm.inventory.notIssued.length > 0
                  ? _c("div", { staticClass: "summary-uniform-item" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover blur",
                                content: `Не выданы позиции: <b>${_vm.inventory.notIssued}</b>`,
                                placement: "top",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: `Не выданы позиции: <b>${inventory.notIssued}</b>`,\n            placement: 'top',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          staticClass:
                            "summary-uniform-item-icon summary-uniform-item-icon-yellow",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "17",
                                height: "14",
                                viewBox: "0 0 17 14",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M10 13H4V5H1V1H5.33333C5.33333 1 6.4 2.5 8 2.5C9.6 2.5 10.6667 1 10.6667 1H15V5H12M10 10H16M16 10L14 8M16 10L14 12",
                                  stroke: "#9FA400",
                                  "stroke-width": "2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-documents-item-text" },
                        [_vm._v(_vm._s(_vm.inventory.notIssued))]
                      ),
                    ])
                  : _vm._e(),
                !_vm.inventory.isLoaded && _vm.inventory.notIssued.length > 0
                  ? _c("div", { staticClass: "summary-uniform-hr" })
                  : _vm._e(),
                !_vm.inventory.isLoaded && _vm.inventory.expired.length > 0
                  ? _c("div", { staticClass: "summary-uniform-item" }, [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.html",
                              value: {
                                container: "#app",
                                trigger: "hover blur",
                                content: `Просроченные позиции: <b>${_vm.inventory.expired}</b>`,
                                placement: "top",
                              },
                              expression:
                                "{\n            container: '#app',\n            trigger: 'hover blur',\n            content: `Просроченные позиции: <b>${inventory.expired}</b>`,\n            placement: 'top',\n          }",
                              modifiers: { html: true },
                            },
                          ],
                          staticClass:
                            "summary-uniform-item-icon summary-uniform-item-icon-red",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "17",
                                height: "15",
                                viewBox: "0 0 17 15",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M5.33333 1L6.14829 0.420476C5.9607 0.15668 5.65703 0 5.33333 0V1ZM1 1V0C0.447715 0 0 0.447715 0 1L1 1ZM1 5H0C0 5.55228 0.447715 6 1 6L1 5ZM4 5H5C5 4.44772 4.55228 4 4 4V5ZM4 13H3C3 13.5523 3.44771 14 4 14V13ZM6 14C6.55228 14 7 13.5523 7 13C7 12.4477 6.55228 12 6 12V14ZM10.6667 1V0C10.343 0 10.0393 0.15668 9.85171 0.420476L10.6667 1ZM15 1H16C16 0.447715 15.5523 0 15 0V1ZM15 5V6C15.5523 6 16 5.55228 16 5H15ZM12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6V4ZM17 8C17 7.44771 16.5523 7 16 7C15.4477 7 15 7.44771 15 8H17ZM16 11V12H17V11H16ZM13 10C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12V10ZM14.4944 9.33329L15.3259 8.77772L14.4944 9.33329ZM9.87868 8.87868L10.5858 9.58579L9.87868 8.87868ZM9.05764 10.4147L8.07686 10.2196L9.05764 10.4147ZM10.3333 13.4944L9.77772 14.3259L10.3333 13.4944ZM12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13V15ZM8 1.5C7.51675 1.5 7.06675 1.27078 6.69306 0.970491C6.51259 0.825477 6.36932 0.679038 6.27241 0.570011C6.22447 0.51608 6.1893 0.472912 6.168 0.445861C6.15739 0.432381 6.15034 0.423051 6.14698 0.418557C6.14531 0.416314 6.14457 0.415293 6.14478 0.41558C6.14488 0.415724 6.14523 0.416197 6.14581 0.417009C6.1461 0.417415 6.14645 0.417906 6.14687 0.418483C6.14707 0.418772 6.1473 0.419082 6.14753 0.419415C6.14765 0.41958 6.14784 0.419846 6.1479 0.419929C6.14809 0.4202 6.14829 0.420476 5.33333 1C4.51838 1.57952 4.51858 1.57981 4.51879 1.58011C4.51887 1.58021 4.51908 1.58051 4.51923 1.58072C4.51953 1.58115 4.51985 1.58159 4.52019 1.58206C4.52086 1.583 4.5216 1.58404 4.52241 1.58517C4.52404 1.58742 4.52593 1.59004 4.52811 1.59303C4.53245 1.59899 4.53789 1.60639 4.54442 1.61513C4.55747 1.63261 4.5749 1.65551 4.59658 1.68305C4.63986 1.73803 4.70053 1.81204 4.77759 1.89874C4.93068 2.07096 5.15407 2.29952 5.44027 2.52951C5.99991 2.97922 6.88325 3.5 8 3.5V1.5ZM0 1V5H2V1H0ZM1 6H4V4H1V6ZM3 5V13H5V5H3ZM4 14H6V12H4V14ZM8 3.5C9.11675 3.5 10.0001 2.97922 10.5597 2.52951C10.8459 2.29952 11.0693 2.07096 11.2224 1.89874C11.2995 1.81204 11.3601 1.73803 11.4034 1.68305C11.4251 1.65551 11.4425 1.63261 11.4556 1.61513C11.4621 1.60639 11.4675 1.59899 11.4719 1.59303C11.4741 1.59004 11.476 1.58742 11.4776 1.58517C11.4784 1.58404 11.4791 1.583 11.4798 1.58206C11.4801 1.58159 11.4805 1.58115 11.4808 1.58072C11.4809 1.58051 11.4811 1.58021 11.4812 1.58011C11.4814 1.57981 11.4816 1.57952 10.6667 1C9.85171 0.420476 9.85191 0.4202 9.8521 0.419929C9.85216 0.419846 9.85235 0.41958 9.85247 0.419414C9.8527 0.419082 9.85293 0.418772 9.85313 0.418483C9.85355 0.417906 9.8539 0.417415 9.85419 0.417009C9.85477 0.416197 9.85512 0.415724 9.85522 0.41558C9.85543 0.415293 9.85469 0.416314 9.85302 0.418557C9.84966 0.423051 9.84261 0.432381 9.832 0.445861C9.8107 0.472912 9.77553 0.51608 9.72759 0.570011C9.63068 0.679038 9.4874 0.825477 9.30694 0.970491C8.93325 1.27078 8.48325 1.5 8 1.5V3.5ZM14 1V5H16V1H14ZM15 4H12V6H15V4ZM5.33333 0H1V2H5.33333V0ZM10.6667 2H15V0H10.6667V2ZM15 8V11H17V8H15ZM13 12H15V10H13V12ZM15 12H16V10H15V12ZM16 11C16 10.2089 15.7654 9.43552 15.3259 8.77772L13.6629 9.88886C13.8827 10.2178 14 10.6044 14 11H16ZM15.3259 8.77772C14.8864 8.11993 14.2616 7.60723 13.5307 7.30448L12.7654 9.15224C13.1308 9.30362 13.4432 9.55996 13.6629 9.88886L15.3259 8.77772ZM13.5307 7.30448C12.7998 7.00173 11.9956 6.92252 11.2196 7.07686L11.6098 9.03843C11.9978 8.96126 12.3999 9.00087 12.7654 9.15224L13.5307 7.30448ZM11.2196 7.07686C10.4437 7.2312 9.73098 7.61216 9.17157 8.17157L10.5858 9.58579C10.8655 9.30608 11.2219 9.1156 11.6098 9.03843L11.2196 7.07686ZM9.17157 8.17157C8.61216 8.73098 8.2312 9.44372 8.07686 10.2196L10.0384 10.6098C10.1156 10.2219 10.3061 9.86549 10.5858 9.58579L9.17157 8.17157ZM8.07686 10.2196C7.92252 10.9956 8.00173 11.7998 8.30448 12.5307L10.1522 11.7654C10.0009 11.3999 9.96126 10.9978 10.0384 10.6098L8.07686 10.2196ZM8.30448 12.5307C8.60723 13.2616 9.11992 13.8864 9.77772 14.3259L10.8889 12.6629C10.56 12.4432 10.3036 12.1308 10.1522 11.7654L8.30448 12.5307ZM9.77772 14.3259C10.4355 14.7654 11.2089 15 12 15V13C11.6044 13 11.2178 12.8827 10.8889 12.6629L9.77772 14.3259Z",
                                  fill: "#FF238D",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-documents-item-text" },
                        [_vm._v(_vm._s(_vm.inventory.expired))]
                      ),
                    ])
                  : _vm._e(),
                !_vm.inventory.isLoaded &&
                _vm.inventory.notIssued.length === 0 &&
                _vm.inventory.expired.length > 0
                  ? _c("div", { staticClass: "summary-uniform-hr" })
                  : _vm._e(),
                !_vm.inventory.isLoaded &&
                _vm.inventory.notIssued.length === 0 &&
                _vm.inventory.expired.length === 0
                  ? _c("div", { staticClass: "summary-uniform-empty" }, [
                      _vm._v(" Нет проблем с инвентарем "),
                    ])
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        _vm.userHavePermissionFinesAndEncourage()
          ? _c(
              "div",
              {
                staticClass: "summary-encourage",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "personal-employee-discipline",
                    })
                  },
                },
              },
              [
                _vm.encourageIsLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-encourage-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.encourageIsLoaded
                  ? _c("div", { staticClass: "summary-encourage-title" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "14",
                            height: "15",
                            viewBox: "0 0 14 15",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M4.04837 13.1935H2.21935C1.89596 13.1935 1.58581 13.065 1.35714 12.8363C1.12847 12.6077 1 12.2975 1 11.9741V7.70642C1 7.38302 1.12847 7.07288 1.35714 6.84421C1.58581 6.61553 1.89596 6.48707 2.21935 6.48707H4.04837M8.31609 5.26772V2.82902C8.31609 2.34394 8.12339 1.87872 7.78038 1.53571C7.43737 1.1927 6.97215 1 6.48707 1L4.04837 6.48707V13.1935H10.9255C11.2196 13.1968 11.5049 13.0937 11.729 12.9033C11.9531 12.7128 12.1007 12.4478 12.1448 12.157L12.9862 6.66997C13.0127 6.49521 13.0009 6.31677 12.9516 6.14702C12.9024 5.97727 12.8168 5.82026 12.7008 5.68688C12.5848 5.55349 12.4412 5.44692 12.2799 5.37454C12.1187 5.30217 11.9436 5.26572 11.7668 5.26772H8.31609Z",
                              stroke: "#12C971",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        { staticClass: "summary-encourage-title-text" },
                        [_vm._v("Поощрения")]
                      ),
                    ])
                  : _vm._e(),
                _vm._l(_vm.encourageLocalItems, function (item, i) {
                  return _c(
                    "div",
                    {
                      key: `encourage-l-${i}-${item.name}`,
                      staticClass: "summary-encourage-item",
                    },
                    [
                      !_vm.encourageIsLoaded
                        ? [
                            _c(
                              "div",
                              { staticClass: "summary-encourage-item-text" },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c(
                              "div",
                              { staticClass: "summary-encourage-item-date" },
                              [_vm._v(_vm._s(item.date))]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                !_vm.encourageIsLoaded && _vm.encourageLocalItems.length === 0
                  ? _c("div", { staticClass: "summary-encourage-empty" }, [
                      _vm._v(" Поощрений пока нет "),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm.userHavePermissionFinesAndEncourage()
          ? _c(
              "div",
              {
                staticClass: "summary-fines",
                on: {
                  click: function ($event) {
                    return _vm.$router.push({
                      name: "personal-employee-discipline",
                    })
                  },
                },
              },
              [
                _vm.finesIsLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-fines-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.finesIsLoaded
                  ? _c("div", { staticClass: "summary-fines-title" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "14",
                            height: "15",
                            viewBox: "0 0 14 15",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M4.04837 1.06457H2.21935C1.89596 1.06457 1.58581 1.19304 1.35714 1.42171C1.12847 1.65039 1 1.96053 1 2.28392V6.55164C1 6.87503 1.12847 7.18518 1.35714 7.41385C1.58581 7.64252 1.89596 7.77099 2.21935 7.77099H4.04837M8.31609 8.99034V11.429C8.31609 11.9141 8.12339 12.3793 7.78038 12.7223C7.43737 13.0654 6.97215 13.2581 6.48707 13.2581L4.04837 7.77099V1.06457H10.9255C11.2196 1.06125 11.5049 1.16431 11.729 1.35478C11.9531 1.54524 12.1007 1.81026 12.1448 2.10102L12.9862 7.58809C13.0127 7.76285 13.0009 7.94128 12.9516 8.11103C12.9024 8.28079 12.8168 8.43779 12.7008 8.57118C12.5848 8.70456 12.4412 8.81114 12.2799 8.88351C12.1187 8.95589 11.9436 8.99234 11.7668 8.99034H8.31609Z",
                              stroke: "#FF238D",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                        ]
                      ),
                      _c("div", { staticClass: "summary-fines-title-text" }, [
                        _vm._v("Частые нарушения"),
                      ]),
                    ])
                  : _vm._e(),
                _vm._l(_vm.finesLocalItems, function (fine) {
                  return _c(
                    "div",
                    {
                      key: `fine-l-${fine.name}`,
                      staticClass: "summary-fines-item",
                    },
                    [
                      !_vm.finesIsLoaded
                        ? [
                            _c(
                              "div",
                              { staticClass: "summary-fines-item-text" },
                              [_vm._v(_vm._s(fine.name))]
                            ),
                            _c(
                              "div",
                              { staticClass: "summary-fines-item-count" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-fines-item-count-text",
                                  },
                                  [_vm._v(_vm._s(fine.count))]
                                ),
                              ]
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  )
                }),
                !_vm.finesIsLoaded && _vm.finesLocalItems.length === 0
                  ? _c("div", { staticClass: "summary-fines-empty" }, [
                      _vm._v("Нарушений пока нет"),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm.notifications.userHasPermission
          ? _c(
              "div",
              { staticClass: "summary-notices" },
              [
                _vm.notifications.isLoaded
                  ? _c(
                      "div",
                      { staticClass: "summary-notices-loader" },
                      [
                        _c("font-awesome-icon", {
                          attrs: { icon: _vm.icon, spin: "" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.notifications.isLoaded
                  ? _c("div", { staticClass: "summary-notices-title" }, [
                      _c("div", { staticClass: "summary-notices-title-text" }, [
                        _vm._v("Уведомления"),
                      ]),
                      _c(
                        "div",
                        {
                          staticClass: "summary-notices-title-count",
                          class: {
                            "summary-notices-title-count-grey":
                              _vm.notifications.count === 0,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "summary-notices-title-count-text" },
                            [_vm._v(_vm._s(_vm.notifications.count))]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._l(
                  _vm.notifications.items,
                  function (notification, mobileIndex) {
                    return _c(
                      "div",
                      {
                        key: "notification" + mobileIndex + "mobile",
                        staticClass: "summary-notices-item",
                      },
                      [
                        !_vm.notifications.isLoaded
                          ? [
                              _c(
                                "div",
                                {
                                  staticClass: "summary-notices-item-text",
                                  domProps: {
                                    innerHTML: _vm._s(notification.text),
                                  },
                                },
                                [_vm._v(_vm._s(notification.text))]
                              ),
                              _c(
                                "div",
                                { staticClass: "summary-notices-item-date" },
                                [_vm._v(_vm._s(notification.created))]
                              ),
                            ]
                          : _vm._e(),
                      ],
                      2
                    )
                  }
                ),
                !_vm.notifications.isLoaded &&
                _vm.notifications.items.length === 0
                  ? _c("div", { staticClass: "summary-notices-empty" }, [
                      _vm._v(" Нет новых уведомлений "),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _c("div", { staticClass: "summary-statuses" }, [
          _vm.statuses.isLoaded
            ? _c(
                "div",
                { staticClass: "summary-statuses-loader" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.icon, spin: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          !_vm.statuses.isLoaded
            ? _c(
                "div",
                {
                  staticClass: "summary-statuses-item",
                  class: {
                    "summary-statuses-item-disabled":
                      _vm.statuses.changeStatusForm.length > 0 &&
                      _vm.statuses.changeStatusForm !== "workerStatus",
                  },
                },
                [
                  _c("div", { staticClass: "summary-statuses-item-title" }, [
                    _vm._v("Статус сотрудника"),
                  ]),
                  _vm.statuses.changeStatusForm !== "workerStatus"
                    ? _c(
                        "div",
                        { staticClass: "summary-statuses-item-value" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-statuses-item-text",
                              class: {
                                "summary-statuses-item-value-text-not-chosen":
                                  _vm.statuses.characteristic === "Не выбрано",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.statuses.workerStatus) + " "
                              ),
                            ]
                          ),
                          _vm.userHavePermissionChangeWorkerStatuses
                            ? _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Редактировать",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass: "summary-statuses-item-value-icon",
                                attrs: { size: "iconic", icon: "edit" },
                                on: {
                                  click: function ($event) {
                                    _vm.statuses.changeStatusForm =
                                      "workerStatus"
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "summary-statuses-item-value align-items-start w-100",
                        },
                        [
                          _c("c-input", {
                            staticClass:
                              "flex-grow-1 summary-statuses-item-value-input",
                            attrs: {
                              type: "select",
                              searchable: true,
                              items: _vm.statuses.workerStatusLocalItem,
                            },
                            model: {
                              value: _vm.statuses.workerStatusLocal,
                              callback: function ($$v) {
                                _vm.$set(_vm.statuses, "workerStatusLocal", $$v)
                              },
                              expression: "statuses.workerStatusLocal",
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Отменить",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            key: "workerStatus1",
                            staticClass:
                              "summary-statuses-item-value-close-icon",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "close", color: "secondary" },
                            },
                            on: {
                              click: function ($event) {
                                _vm.statuses.changeStatusForm = ""
                              },
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Сохранить",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            key: "workerStatus2",
                            staticClass:
                              "summary-statuses-item-value-apply-icon",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "check", color: "success" },
                            },
                            on: { click: _vm.changeStatuses },
                          }),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
          !_vm.statuses.isLoaded && _vm.userHavePermissionCharacteristic()
            ? _c(
                "div",
                {
                  staticClass: "summary-statuses-item",
                  class: {
                    "summary-statuses-item-disabled":
                      _vm.statuses.changeStatusForm.length > 0 &&
                      _vm.statuses.changeStatusForm !== "characteristic",
                  },
                },
                [
                  _c("div", { staticClass: "summary-statuses-item-title" }, [
                    _vm._v("Характеристика"),
                  ]),
                  _vm.statuses.changeStatusForm !== "characteristic"
                    ? _c(
                        "div",
                        { staticClass: "summary-statuses-item-value" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-statuses-item-text",
                              class: {
                                "summary-statuses-item-value-text-not-chosen":
                                  _vm.statuses.characteristic === "Не выбрано",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.statuses.characteristic) + " "
                              ),
                            ]
                          ),
                          _vm.statuses.rankInfo !== null
                            ? _c("c-rank-info-icon", {
                                staticClass:
                                  "summary-statuses-item-rankinfo-icon",
                                attrs: {
                                  "icon-key": "rankinfo-summary-mobile",
                                  data: {
                                    action: _vm.statuses.rankInfo.action,
                                    value: _vm.statuses.rankInfo.value,
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm.userHavePermissionChangeWorkerStatuses()
                            ? _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Редактировать",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass: "summary-statuses-item-value-icon",
                                attrs: { size: "iconic", icon: "edit" },
                                on: {
                                  click: function ($event) {
                                    _vm.statuses.changeStatusForm =
                                      "characteristic"
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "summary-statuses-item-value align-items-start w-100",
                        },
                        [
                          _c("c-input", {
                            staticClass:
                              "flex-grow-1 summary-statuses-item-value-input",
                            attrs: {
                              type: "select",
                              searchable: true,
                              items: _vm.statuses.characteristicLocalItems,
                            },
                            model: {
                              value: _vm.statuses.characteristicLocalValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.statuses,
                                  "characteristicLocalValue",
                                  $$v
                                )
                              },
                              expression: "statuses.characteristicLocalValue",
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Отменить",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            key: "workerStatus1",
                            staticClass:
                              "summary-statuses-item-value-close-icon",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "close", color: "secondary" },
                            },
                            on: {
                              click: function ($event) {
                                _vm.statuses.changeStatusForm = ""
                              },
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Сохранить",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            key: "workerStatus2",
                            staticClass:
                              "summary-statuses-item-value-apply-icon",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "check", color: "success" },
                            },
                            on: { click: _vm.changeStatuses },
                          }),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
          !_vm.statuses.isLoaded
            ? _c(
                "div",
                {
                  staticClass: "summary-statuses-item",
                  class: {
                    "summary-statuses-item-disabled":
                      _vm.statuses.changeStatusForm.length > 0 &&
                      _vm.statuses.changeStatusForm !== "employmentStatus",
                  },
                },
                [
                  _c("div", { staticClass: "summary-statuses-item-title" }, [
                    _vm._v("Статус трудоустройства"),
                  ]),
                  _vm.statuses.changeStatusForm !== "employmentStatus"
                    ? _c(
                        "div",
                        { staticClass: "summary-statuses-item-value" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "summary-statuses-item-text",
                              class: {
                                "summary-statuses-item-value-text-not-chosen":
                                  _vm.statuses.employmentStatus ===
                                  "Не выбрано",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.statuses.employmentStatus) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.userHavePermissionChangeWorkerStatuses()
                            ? _c("c-button", {
                                directives: [
                                  {
                                    name: "b-popover",
                                    rawName: "v-b-popover.html",
                                    value: {
                                      container: "#app",
                                      trigger: "hover blur",
                                      content: "Редактировать",
                                      placement: "top",
                                    },
                                    expression:
                                      "{\n              container: '#app',\n              trigger: 'hover blur',\n              content: 'Редактировать',\n              placement: 'top',\n            }",
                                    modifiers: { html: true },
                                  },
                                ],
                                staticClass: "summary-statuses-item-value-icon",
                                attrs: { size: "iconic", icon: "edit" },
                                on: {
                                  click: function ($event) {
                                    _vm.statuses.changeStatusForm =
                                      "employmentStatus"
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "summary-statuses-item-value align-items-start w-100",
                        },
                        [
                          _c("c-input", {
                            staticClass:
                              "flex-grow-1 summary-statuses-item-value-input",
                            attrs: {
                              type: "select",
                              searchable: true,
                              items: _vm.statuses.employmentStatusLocalItems,
                            },
                            model: {
                              value: _vm.statuses.employmentStatusLocalValue,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.statuses,
                                  "employmentStatusLocalValue",
                                  $$v
                                )
                              },
                              expression: "statuses.employmentStatusLocalValue",
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Отменить",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Отменить', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            key: "workerStatus1",
                            staticClass:
                              "summary-statuses-item-value-close-icon",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "close", color: "secondary" },
                            },
                            on: {
                              click: function ($event) {
                                _vm.statuses.changeStatusForm = ""
                              },
                            },
                          }),
                          _c("c-button", {
                            directives: [
                              {
                                name: "b-popover",
                                rawName: "v-b-popover.html",
                                value: {
                                  container: "#app",
                                  trigger: "hover blur",
                                  content: "Сохранить",
                                  placement: "top",
                                },
                                expression:
                                  "{ container: '#app', trigger: 'hover blur', content: 'Сохранить', placement: 'top' }",
                                modifiers: { html: true },
                              },
                            ],
                            key: "workerStatus2",
                            staticClass:
                              "summary-statuses-item-value-apply-icon",
                            attrs: {
                              size: "iconic",
                              icon: { icon: "check", color: "success" },
                            },
                            on: { click: _vm.changeStatuses },
                          }),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
          !_vm.statuses.isLoaded
            ? _c(
                "div",
                {
                  staticClass: "summary-statuses-additions",
                  class: {
                    "summary-statuses-additions-disabled":
                      _vm.statuses.changeStatusForm === "characteristic" ||
                      _vm.statuses.changeStatusForm === "employmentStatus" ||
                      _vm.statuses.changeStatusForm === "workerStatus",
                  },
                },
                [
                  _vm.statuses.combinationFilials
                    ? _c(
                        "div",
                        { staticClass: "summary-statuses-additions-item" },
                        [
                          _c("c-button", {
                            attrs: { icon: "point", size: "iconic" },
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "summary-statuses-additions-item-text",
                            },
                            [_vm._v("Может работать в нескольких филиалах")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.statuses.remoteJob
                    ? _c(
                        "div",
                        { staticClass: "summary-statuses-additions-item" },
                        [
                          _c("c-button", {
                            attrs: { icon: "home", size: "iconic" },
                          }),
                          _c(
                            "div",
                            {
                              staticClass:
                                "summary-statuses-additions-item-text",
                            },
                            [_vm._v("Может работать удалённо")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }